import React from "react";
import ModalForm from "./ModalForm";
import { SampleEdit } from "../../types/Sample";
import { parseDate, toLocalDateTime, getDateOrNull, showModalNoOutsideClick, getNameFromID, hideModal, getLabel, getLabelForBinAndBatch, getBoolOptionsWithNullValue, getBoolSelectOptions, parseDateForCustomDate, getLabelFromName } from "../../util/FormatUtil";
import moment from "moment";
import { AiFillEye, AiOutlineDown, AiOutlineUp, AiOutlineCheckCircle, AiOutlineClose, AiOutlineCloudDownload } from "react-icons/ai";
import Overlay from "../Overlay";
import { isBlank, isOnlyWhitespace, } from "../../util/ValidationUtil";
import { sweetalert } from "../../App";
import SamplesAPI from "../../network/SamplesAPI";
import Validator, { ValidationEntry } from "../../validation/Validator";
import { Validators } from "../../validation/Validators";
import { CustomFieldBuilder } from "../../customfields/CustomFieldBuilder";
import { InsuranceImageModal } from "./InsuranceImageModal";
import { SampleInsuranceCardModal } from "./SamplesInsuranceCardModal";
import { isMobile } from "react-device-detect";
import { InsuranceCardUploadModal } from "./InsuranceCardUploadModal";
import InBetweenOverlay from "../InBetweenOverlay";
import GetField from "../../customfields/GetField";
import { isEmptyObject } from "jquery";
import CustomInput from "../form/CustomInput";
import CustomTextArea from "../form/CustomTextArea";
import CustomSelect from "../form/CustomSelect";
import CustomDate from '../form/CustomDate';
import CustomPhone from "../form/CustomPhone";
import Dropzone from 'react-dropzone';
import { downloadSampleDocuments, promptDocumentSelection } from "../../util/SampleDocumentsUtil";
import SubmissionAPI from "../../network/SubmissionAPI";
import { demoEssentialAndComprehensiveServiceIDs, developmentEssentialAndComprehensiveServiceIDs, productionEssentialAndComprehensiveServiceIDs } from "../../types/Service";
import AutoComplete from "../admin/Autocomplete";
import AnimalSamplesAPI from "../../network/AnimalSamplesAPI";
import { getFieldReadOnly, FieldPermissions } from "../../util/RolePermissions";

interface ResultProps {
  selectedSample?;
  states?;
  statuses?;
  countries?;
  ethnicity?;
  race?;
  gender?;
  specimen_source?;
  validSpecimenSources?;
  tests?;
  testDetails?;
  result_types?;
  validResultTypes?;
  facilities?;
  pods?;
  binIDs?;
  batches?;
  getPhysicianReviewButtonBoolean?: boolean;
  isGlobal?;
  isAdmin?;
  customQuestions?;
  customFields?;
  customSubmitterFields?;
  onSubmit: (reportsGenerating?: boolean) => void;
  services?;
  animalTypes?;
  userRoles?;
  fieldPermissions?: FieldPermissions;
}

interface ResultState {
  submitterArrowDown: boolean;
  appointmentArrowDown: boolean;
  sampleArrowDown: boolean;
  rabiesArrowDown: boolean;
  testArrowDown: boolean;
  facilityArrowDown: boolean;
  insuranceArrowDown: boolean;
  fileUploadArrowDown: boolean;
  additionalArrowDown: boolean;
  customFieldDataArrowDown: boolean;
  questionnaireDataArrowDown: boolean;
  submitClicked: boolean;
  showLoading: boolean;
  eyeColor: boolean;
  frontInsuranceCardImage: string;
  backInsuranceCardImage: string;
  frontCardImgFile: File;
  backCardImgFile: File;
  imageSaved: boolean;
  showInBetween: boolean;
  captureClicked: boolean;
  showSSN: boolean;
  imageCached: boolean;
  selectedSample?;
  showLoadingForViewInsuranceCards: boolean;
  showLoadingForPhysicianReview: boolean;
  selectedFiles;
  fileNames?;
  emailOrPhoneChange: boolean
  searchAddress?
}

export class AnimalSamplesModal extends React.Component<ResultProps, ResultState> {
  public formRef: React.RefObject<ModalForm>;
  public static ID = "animalSample";
  constructor(props) {
    super(props);
    this.state = {
      frontInsuranceCardImage: "",
      backInsuranceCardImage: "",
      frontCardImgFile: null,
      backCardImgFile: null,
      imageSaved: false,
      showInBetween: false,
      captureClicked: false,
      showSSN: false,
      imageCached: false,
      showLoadingForViewInsuranceCards: false,
      showLoadingForPhysicianReview: false,
      submitterArrowDown: false,
      appointmentArrowDown: false,
      sampleArrowDown: false,
      rabiesArrowDown: false,
      testArrowDown: false,
      facilityArrowDown: false,
      additionalArrowDown: false,
      insuranceArrowDown: false,
      fileUploadArrowDown: false,
      customFieldDataArrowDown: false,
      questionnaireDataArrowDown: false,
      submitClicked: false,
      showLoading: false,
      eyeColor: false,
      selectedFiles: [],
      fileNames: [],
      emailOrPhoneChange: false
    };
    this.formRef = React.createRef();
  }

  componentDidMount(): void {
    $(`#${AnimalSamplesModal.ID}`).on('shown.bs.modal', function () {
      $(document).off('focusin.modal');
    });
  }

  componentWillReceiveProps(
    nextProps: Readonly<ResultProps>,
    nextContext: any
  ) {

    if (!isEmptyObject(nextProps.selectedSample)) {
      let selectedSample = nextProps.selectedSample;

      let apptTime = selectedSample.ApptTime;
      let fakeDate = new Date("1970/01/01 " + apptTime);

      let pods = [];
      this.props.pods.map(p => {
        p.options.map(o => {
          pods.push({ label: o.label, value: o.value.ID })
        })
      })

      let rabiesExposureInfo = selectedSample.RabiesExposureInfo ? JSON.parse(selectedSample.RabiesExposureInfo) : [];
      rabiesExposureInfo.forEach((r, i) => {
        rabiesExposureInfo[i].ExposedSpecies = getLabel(r.ExposedSpecies, [{ label: "Human", value: 1 }, { label: "Animal", value: 2 }]);
        rabiesExposureInfo[i].ExposureType = getLabel(r.ExposureType, [{ label: "Bite", value: 1 }, { label: "Scratch", value: 2 }, { label: "Other", value: 3 }]);
        rabiesExposureInfo[i].State = getLabel(r.State, this.props.states);
      })


      this.setState({
        selectedSample: {
          sampleID: selectedSample && selectedSample.ID ? selectedSample.ID : null,
          submitterPortalUID: selectedSample && selectedSample.SubmitterPortalUID ? selectedSample.SubmitterPortalUID : "",
          linkedApptsID: selectedSample && selectedSample.LinkedApptsID ? selectedSample.LinkedApptsID : "",
          reqNum: selectedSample && selectedSample.ReqNum ? selectedSample.ReqNum : "",
          animalType: selectedSample && selectedSample.AnimalType ?selectedSample.AnimalType : "",
          animalTypeLabel: selectedSample && selectedSample.AnimalType ? getLabel(selectedSample.AnimalType, this.props.animalTypes) : "",
          specimenID: selectedSample && selectedSample.SpecimenID ? selectedSample.SpecimenID : "",
          bodySite: selectedSample && selectedSample.BodySite ? selectedSample.BodySite : "",
          internalSpecimenID: selectedSample && selectedSample.InternalSpecimenID ? selectedSample.InternalSpecimenID : "",
          memo: selectedSample && selectedSample.Memo ? selectedSample.Memo : "",
          submitterID: selectedSample && selectedSample.SubmitterID ? selectedSample.SubmitterID : "",
          submitterFirstName: selectedSample && selectedSample.SubmitterFirstName ? selectedSample.SubmitterFirstName : "",
          submitterMiddleName: selectedSample && selectedSample.SubmitterMiddleName ? selectedSample.SubmitterMiddleName : "",
          submitterLastName: selectedSample && selectedSample.SubmitterLastName ? selectedSample.SubmitterLastName : "",
          submitterDOB: selectedSample && selectedSample.SubmitterDOB ? parseDateForCustomDate(selectedSample.SubmitterDOB, false) : null,
          submitterZip: selectedSample && selectedSample.SubmitterZipcode ? selectedSample.SubmitterZipcode : "",
          submitterCity: selectedSample && selectedSample.SubmitterCity ? selectedSample.SubmitterCity : "",
          submitterState: selectedSample && selectedSample.SubmitterState ? selectedSample.SubmitterState : "",
          submitterCounty: selectedSample && selectedSample.SubmitterCounty ? selectedSample.SubmitterCounty : "",
          submitterCountry: selectedSample && selectedSample.SubmitterCountry && selectedSample.SubmitterCountry === 'United States of America' ? 'United States' : selectedSample && selectedSample.SubmitterCountry ? selectedSample.SubmitterCountry : "",
          submitterAddress: selectedSample && selectedSample.SubmitterStreetAddress ? selectedSample.SubmitterStreetAddress : "",
          submitterEmail: selectedSample && selectedSample.SubmitterEmail ? selectedSample.SubmitterEmail : "",
          submitterPhone: selectedSample && selectedSample.SubmitterPhone ? selectedSample.SubmitterPhone : "",
          submitterEthnicityID: selectedSample && selectedSample.SubmitterEthnicityID ? selectedSample.SubmitterEthnicityID : "",
          submitterRaceID: selectedSample && selectedSample.SubmitterRaceID ? selectedSample.SubmitterRaceID : "",
          submitterGenderID: selectedSample && selectedSample.SubmitterGenderID ? selectedSample.SubmitterGenderID : "",
          guardianFirstName: selectedSample && selectedSample.GuardianFirstName ? selectedSample.GuardianFirstName : "",
          guardianLastName: selectedSample && selectedSample.GuardianLastName ? selectedSample.GuardianLastName : "",
          // providerFirstName: selectedSample && selectedSample.ProviderFirstName ? selectedSample.ProviderFirstName : "",
          // providerLastName: selectedSample && selectedSample.ProviderLastName ? selectedSample.ProviderLastName : "",
          binID: selectedSample && selectedSample.SampleReceivedID ? selectedSample.SampleReceivedID : "",
          bin: selectedSample && selectedSample.SampleReceivedID ? getLabelForBinAndBatch(selectedSample.SampleReceivedID, this.props.binIDs) : "",
          batchNum: selectedSample && selectedSample.BatchID ? selectedSample.BatchID : "",
          batchNums: selectedSample && selectedSample.BatchID ? getLabelForBinAndBatch(selectedSample.BatchID, this.props.batches) : "",
          wellSlot: selectedSample && selectedSample.WellSlot ? selectedSample.WellSlot : "",
          collectionDate: selectedSample && selectedSample.CollectionDate ? parseDateForCustomDate(selectedSample.CollectionDate, true) : null,
          specimenSourceID: selectedSample && selectedSample.SpecimenSourceID ? selectedSample.SpecimenSourceID : "",
          testIDs: selectedSample && selectedSample.TestIDs ? JSON.parse(selectedSample.TestIDs) : null,
          processedDate: selectedSample && selectedSample.ProcessedDate ? parseDateForCustomDate(selectedSample.ProcessedDate, true) : null,
          receivedBy: selectedSample && selectedSample["ReceivedBy"] ? selectedSample["ReceivedBy"] : "",
          receivedDate: selectedSample && selectedSample.ReceivedDate ? parseDateForCustomDate(selectedSample.ReceivedDate, true) : null,
          testOrderedDate: selectedSample && selectedSample.TestOrderedDate ? parseDateForCustomDate(selectedSample.TestOrderedDate, true) : null,
          apptTime: selectedSample && selectedSample.ApptTime ? fakeDate : null,
          podApptID: selectedSample && selectedSample.PodApptID ? selectedSample.PodApptID : "",
          apptCanceled: selectedSample && selectedSample.ApptCanceled ? selectedSample.ApptCanceled : "",
          rerunCount: selectedSample && selectedSample.RerunCount ? selectedSample.RerunCount : "",
          rerunFlag: selectedSample && selectedSample.RerunFlag ? selectedSample.RerunFlag : "",
          consentFlag: selectedSample && selectedSample.ConsentFlag ? selectedSample.ConsentFlag : "",
          reason: selectedSample && selectedSample.Reason ? selectedSample.Reason : "",
          testResultDate: selectedSample && selectedSample.TestResultDate ? parseDateForCustomDate(selectedSample.TestResultDate, true) : null,
          // testResultDate: selectedSample && selectedSample.TestResultDate ? toLocalDateTime(selectedSample.TestResultDate) : null,
          reportedDate: selectedSample && selectedSample.ReportedDate ? parseDateForCustomDate(selectedSample.ReportedDate, true) : null,
          createdDate: selectedSample && selectedSample.CreatedDate ? parseDateForCustomDate(selectedSample.CreatedDate, true) : null,
          facilityID: selectedSample && selectedSample.FacilityID ? selectedSample.FacilityID : "",
          resultsAccessedDate: selectedSample && selectedSample.ResultsAccessedDate ? parseDateForCustomDate(selectedSample.ResultsAccessedDate, true) : null,
          facilityName: selectedSample && selectedSample.FacilityID ? getLabel(selectedSample.FacilityID, this.props.facilities) : "",
          submitterEthnicity: selectedSample && selectedSample.SubmitterEthnicityID ? getLabel(selectedSample.SubmitterEthnicityID, this.props.ethnicity) : "",
          submitterRace: selectedSample && selectedSample.SubmitterRaceID ? getLabel(selectedSample.SubmitterRaceID, this.props.race) : "",
          submitterGender: selectedSample && selectedSample.SubmitterGenderID ? getLabel(selectedSample.SubmitterGenderID, this.props.gender) : "",
          specimenSource: selectedSample && selectedSample.SpecimenSourceID ? getLabel(selectedSample.SpecimenSourceID, this.props.specimen_source) : "",
          podLabel: selectedSample && selectedSample.PodApptID ? getLabel(selectedSample.PodApptID, pods) : "",
          stateLabel: selectedSample && selectedSample.SubmitterState ? getLabel(selectedSample.SubmitterState, this.props.states) : "",
          insuredStateLabel: selectedSample && selectedSample.InsuredState ? getLabel(selectedSample.InsuredState, this.props.states) : "",
          countryLabel: selectedSample && selectedSample.SubmitterCountry && selectedSample.SubmitterCountry === 'United States of America' ? getLabel('United States', this.props.countries) : selectedSample && selectedSample.SubmitterCountry ? getLabel(selectedSample.SubmitterCountry, this.props.countries) : "",
          apptCanceledLabel: selectedSample && selectedSample.ApptCanceled ? getLabel(selectedSample.ApptCanceled, getBoolOptionsWithNullValue()) : "",
          consentFlagLabel: selectedSample && selectedSample.ConsentFlag ? getLabel(selectedSample.ConsentFlag, getBoolOptionsWithNullValue()) : "",
          rerunFlagLabel: selectedSample && selectedSample.RerunFlag ? getLabel(selectedSample.RerunFlag, getBoolOptionsWithNullValue()) : "",
          resultApprovedDate: selectedSample && selectedSample.ResultApprovedDate ? parseDateForCustomDate(selectedSample.ResultApprovedDate, true) : null,
          createdBy: selectedSample && selectedSample.CreatedBy ? selectedSample.CreatedBy : "",
          lastUpdatedBy: selectedSample && selectedSample.LastUpdatedBy ? selectedSample.LastUpdatedBy : "",
          lastUpdatedDate: selectedSample && selectedSample.LastUpdatedDate ? parseDateForCustomDate(selectedSample.LastUpdatedDate, true) : null,
          lot: selectedSample && selectedSample.Lot ? selectedSample.Lot : "",
          CustomFieldData: selectedSample && selectedSample.CustomFieldData ? JSON.parse(selectedSample.CustomFieldData) : null,
          ServiceID: selectedSample && selectedSample.ServiceID ? selectedSample.ServiceID : "",
          insuredFirstName: selectedSample && selectedSample.InsuredFirstName ? selectedSample.InsuredFirstName : "",
          insuredLastName: selectedSample && selectedSample.InsuredLastName ? selectedSample.InsuredLastName : "",
          insuredSSN: selectedSample && selectedSample.InsuredSSN ? selectedSample.InsuredSSN : "",
          insuredDOB: selectedSample && selectedSample.InsuredDOB ? parseDate(selectedSample.InsuredDOB) : null,
          insuredMRN: selectedSample && selectedSample.InsuredMRN ? selectedSample.InsuredMRN : "",
          insuredAddressLine1: selectedSample && selectedSample.InsuredAddressLine1 ? selectedSample.InsuredAddressLine1 : "",
          insuredAddressLine2: selectedSample && selectedSample.InsuredAddressLine2 ? selectedSample.InsuredAddressLine2 : "",
          insuredCity: selectedSample && selectedSample.InsuredCity ? selectedSample.InsuredCity : "",
          insuredState: selectedSample && selectedSample.InsuredState ? selectedSample.InsuredState : "",
          insuredZip: selectedSample && selectedSample.InsuredZip ? selectedSample.InsuredZip : "",
          insuredFrontCard: selectedSample && selectedSample.InsuredFrontCardURL ? selectedSample.InsuredFrontCardURL : "",
          insuredBackCard: selectedSample && selectedSample.InsuredBackCardURL ? selectedSample.InsuredBackCardURL : "",
          IncludeInHL7: (selectedSample && selectedSample.IncludeInHL7 === 1) || selectedSample.IncludeInHL7 === 0 ? selectedSample.IncludeInHL7 : "",
          IncludeInHL7Label: selectedSample && selectedSample.IncludeInHL7 ? { label: "Yes", value: 1 } : { label: "No", value: 0 },
          testsAndResultsMap: selectedSample && selectedSample.TestsAndResultsMap ? JSON.parse(selectedSample.TestsAndResultsMap) : null,
          resultIDs: selectedSample && selectedSample.ResultIDs ? JSON.parse(selectedSample.ResultIDs) : null,
          resultsReviewed: selectedSample && selectedSample.HasPhysicianReviewed ? selectedSample.HasPhysicianReviewed : null,
          fileNames: selectedSample && selectedSample.FileUploadPaths ? this.getFileNames(selectedSample.FileUploadPaths) : [],
          status: selectedSample && selectedSample.Status ? selectedSample.Status : "",
          statusLabel: selectedSample && selectedSample.Status ? getLabel(selectedSample.Status, this.props.statuses) : "",
          RabiesExposureInfo: selectedSample && selectedSample.RabiesExposureInfo ? rabiesExposureInfo : "",
          SubmitterContactID: selectedSample && selectedSample.SubmitterContactID ? selectedSample.SubmitterContactID : null,
          SubmittingProvider: selectedSample && selectedSample.SubmittingProvider ? selectedSample.SubmittingProvider : "",
        },
      });
    } else {
      this.setState({
        selectedSample: {
          sampleID: null,
          submitterPortalUID: "",
          linkedApptsID: "",
          reqNum: "",
          specimenID: "",
          bodySite: "",
          internalSpecimenID: "",
          memo: "",
          submitterFirstName: "",
          submitterMiddleName: "",
          submitterLastName: "",
          submitterDOB: null,
          submitterZip: "",
          submitterCity: "",
          submitterState: "",
          submitterCounty: "",
          submitterCountry: "",
          submitterAddress: "",
          submitterEmail: "",
          submitterPhone: "",
          submitterEthnicityID: "",
          submitterRaceID: "",
          submitterGenderID: "",
          guardianFirstName: "",
          guardianLastName: "",
          // providerFirstName: "",
          // providerLastName: "",
          binID: "",
          bin: "",
          batchNum: "",
          batchNums: "",
          wellSlot: "",
          collectionDate: null,
          specimenSourceID: "",
          testIDs: null,
          processedDate: null,
          receivedBy: "",
          receivedDate: null,
          testOrderedDate: null,
          apptTime: null,
          podApptID: "",
          apptCanceled: "",
          rerunCount: "",
          rerunFlag: "",
          consentFlag: "",
          resultIDs: null,
          reason: "",
          testResultDate: null,
          reportedDate: null,
          createdDate: null,
          facilityID: "",
          resultsAccessedDate: null,
          facilityName: "",
          submitterEthnicity: "",
          submitterRace: "",
          submitterGender: "",
          specimenSource: "",
          podLabel: "",
          stateLabel: "",
          insuredStateLabel: "",
          countryLabel: "",
          apptCanceledLabel: "",
          consentFlagLabel: "",
          rerunFlagLabel: "",
          resultApprovedDate: null,
          createdBy: "",
          lastUpdatedBy: "",
          lastUpdatedDate: null,
          lot: "",
          CustomFieldData: null,
          serviceID: "",
          insuredFirstName: "",
          insuredLastName: "",
          insuredSSN: "",
          insuredDOB: null,
          insuredMRN: "",
          insuredAddressLine1: "",
          insuredAddressLine2: "",
          insuredCity: "",
          insuredState: "",
          insuredZip: "",
          insuredFrontCard: "",
          insuredBackCard: "",
          IncludeInHL7: "",
          IncludeInHL7Label: "",
          testsAndResultsMap: null,
          resultsReviewed: null,
          fileNames: [],
          status: "",
          statusLabel: "",
          RabiesExposureInfo: [],
          SubmitterContactID: null,
          SubmittingProvider: ""
        },
      });
    }
  }

  getFileNames(urlArray) {
    let parsedArray = JSON.parse(urlArray);
    let namesOnly = [];
    parsedArray.map(f => {
      let temp = f.split('/').pop();
      namesOnly.push(temp)
    })
    return namesOnly

  }

  getEdittedObj() {
    return {
      ID: this.state.selectedSample?.sampleID,
      submitterPortalUID: this.state.selectedSample?.submitterPortalUID ? this.state.selectedSample?.submitterPortalUID.trim() : null,
      LinkedApptsID: this.state.selectedSample?.linkedApptsID ? this.state.selectedSample.linkedApptsID.trim() : null,
      ReqNum: this.state.selectedSample?.reqNum ? this.state.selectedSample?.reqNum.trim() : null,
      SpecimenID: this.state.selectedSample?.specimenID ? this.state.selectedSample?.specimenID.trim() : null,
      InternalSpecimenID: this.state.selectedSample?.internalSpecimenID ? this.state.selectedSample?.internalSpecimenID.trim() : null,
      Memo: this.state.selectedSample?.memo ? this.state.selectedSample?.memo.trim() : null,
      SubmitterFirstName: this.state.selectedSample?.submitterFirstName ? this.state.selectedSample?.submitterFirstName.trim() : null,
      SubmitterMiddleName: this.state.selectedSample?.submitterMiddleName ? this.state.selectedSample?.submitterMiddleName.trim() : null,
      SubmitterLastName: this.state.selectedSample?.submitterLastName ? this.state.selectedSample?.submitterLastName.trim() : null,
      SubmitterDOB: getDateOrNull(this.state.selectedSample?.submitterDOB),
      SubmitterZip: this.state.selectedSample?.submitterZip ? this.state.selectedSample?.submitterZip.trim() : null,
      SubmitterCity: this.state.selectedSample?.submitterCity ? this.state.selectedSample?.submitterCity.trim() : null,
      SubmitterState: this.state.selectedSample?.stateLabel ? this.state.selectedSample?.stateLabel.value : null,
      SubmitterCounty: this.state.selectedSample?.submitterCounty ? this.state.selectedSample?.submitterCounty.trim() : null,
      SubmitterCountry: this.state.selectedSample?.countryLabel ? this.state.selectedSample?.countryLabel.value : null,
      SubmitterAddress: this.state.selectedSample?.submitterAddress ? this.state.selectedSample?.submitterAddress.trim() : null,
      SubmitterEmail: this.state.selectedSample?.submitterEmail ? this.state.selectedSample?.submitterEmail.trim() : null,
      SubmitterPhone: this.state.selectedSample?.submitterPhone ? this.state.selectedSample?.submitterPhone.trim() : null,
      SubmitterEthnicityID: this.state.selectedSample?.submitterEthnicity ? this.state.selectedSample?.submitterEthnicity.value : null,
      SubmitterRaceID: this.state.selectedSample?.submitterRaceID ? this.state.selectedSample?.submitterRace.value : null,
      SubmitterGenderID: this.state.selectedSample?.submitterGender ? this.state.selectedSample?.submitterGender.value : null,
      GuardianFirstName: this.state.selectedSample?.guardianFirstName ? this.state.selectedSample?.guardianFirstName.trim() : null,
      GuardianLastName: this.state.selectedSample?.guardianLastName ? this.state.selectedSample?.guardianLastName.trim() : null,
      // ProviderFirstName: this.state.selectedSample?.providerFirstName ? this.state.selectedSample?.providerFirstName.trim() : null,
      // ProviderLastName: this.state.selectedSample?.providerLastName ? this.state.selectedSample?.providerLastName.trim() : null,
      SampleReceivedID: this.state.selectedSample?.binID ? this.state.selectedSample?.bin.value.ID : null,
      BatchID: this.state.selectedSample?.batchNum ? this.state.selectedSample?.batchNums.value.ID : null,
      WellSlot: this.state.selectedSample?.wellSlot ? this.state.selectedSample?.wellSlot.trim() : null,
      CollectionDate: getDateOrNull(this.state.selectedSample?.collectionDate),
      SpecimenSourceID: this.state.selectedSample?.specimenSourceID ? this.state.selectedSample?.specimenSourceID : null,
      TestIDs: this.state.selectedSample?.testIDs ? this.state.selectedSample?.testIDs : null,
      ProcessedDate: getDateOrNull(this.state.selectedSample?.processedDate),
      TestOrderedDate: getDateOrNull(this.state.selectedSample?.testOrderedDate),
      ApptTime: this.state.selectedSample?.apptTime ? moment(this.state.selectedSample?.apptTime, "hh:mm a").format("hh:mm a") : null,
      PodApptID: this.state.selectedSample?.podLabel ? this.state.selectedSample?.podLabel.value : null,
      ApptCanceled: this.state.selectedSample?.apptCanceledLabel ? this.state.selectedSample?.apptCanceledLabel.value : null,
      RerunCount: this.state.selectedSample?.rerunCount ? this.state.selectedSample?.rerunCount : null,
      RerunFlag: this.state.selectedSample?.rerunFlagLabel ? this.state.selectedSample?.rerunFlagLabel.value : null,
      ConsentFlag: this.state.selectedSample?.consentFlagLabel ? this.state.selectedSample?.consentFlagLabel.value : null,
      ResultIDs: this.state.selectedSample?.resultIDs ? this.state.selectedSample?.resultIDs : null,
      Reason: this.state.selectedSample?.reason ? this.state.selectedSample?.reason.trim() : null,
      TestResultDate: getDateOrNull(this.state.selectedSample?.testResultDate),
      ReportedDate: getDateOrNull(this.state.selectedSample?.reportedDate),
      CreatedDate: getDateOrNull(this.state.selectedSample?.createdDate),
      FacilityID: this.state.selectedSample?.facilityID ? this.state.selectedSample?.facilityName.value : null,
      ResultsAccessedDate: getDateOrNull(this.state.selectedSample?.resultsAccessedDate),
      Lot: this.state.selectedSample?.lot ? this.state.selectedSample?.lot.trim() : null,
      CustomFieldData: this.state.selectedSample?.CustomFieldData ? this.state.selectedSample?.CustomFieldData : null,
      ServiceID: this.state.selectedSample?.ServiceID ? this.state.selectedSample?.ServiceID : null,
      InsuredFirstName: this.state.selectedSample?.insuredFirstName ? this.state.selectedSample?.insuredFirstName.trim() : null,
      InsuredLastName: this.state.selectedSample?.insuredLastName ? this.state.selectedSample?.insuredLastName.trim() : null,
      InsuredSSN: this.state.selectedSample?.insuredSSN ? this.state.selectedSample?.insuredSSN.replace(/-/g, "").trim() : null,
      InsuredDOB: getDateOrNull(this.state.selectedSample?.insuredDOB),
      InsuredMRN: this.state.selectedSample?.insuredMRN ? this.state.selectedSample?.insuredMRN.trim() : null,
      InsuredAddressLine1: this.state.selectedSample?.insuredAddressLine1 ? this.state.selectedSample?.insuredAddressLine1.trim() : null,
      InsuredAddressLine2: this.state.selectedSample?.insuredAddressLine2 ? this.state.selectedSample?.insuredAddressLine2.trim() : null,
      InsuredCity: this.state.selectedSample?.insuredCity ? this.state.selectedSample?.insuredCity.trim() : null,
      InsuredState: this.state.selectedSample?.insuredStateLabel ? this.state.selectedSample?.insuredStateLabel.value : null,
      InsuredZip: this.state.selectedSample?.insuredZip ? this.state.selectedSample?.insuredZip.trim() : null,
      InsuredFrontCard: this.state.selectedSample.insuredFrontCard ? this.state.selectedSample.insuredFrontCard : null,
      InsuredBackCard: this.state.selectedSample.insuredBackCard ? this.state.selectedSample.insuredBackCard : null,
      IncludeInHL7: this.state.selectedSample?.IncludeInHL7 ? this.state.selectedSample.IncludeInHL7 : null,
      TestsAndResultsMap: this.state.selectedSample?.testsAndResultsMap ? this.state.selectedSample?.testsAndResultsMap : null,
      Status: this.state.selectedSample?.statusLabel ? this.state.selectedSample?.statusLabel.value : null,
      SubmitterContactID: this.state.selectedSample?.SubmitterContactID ? this.state.selectedSample?.SubmitterContactID : null,
      SubmittingProvider: this.state.selectedSample?.SubmittingProvider ? this.state.selectedSample?.SubmittingProvider : null,
    };
  }

  onSubmit() {
    this.setState({ emailOrPhoneChange: false })
    if (this.state.selectedSample.specimenID.length > 0 && this.state.selectedSample.specimenID.length < 8 ) {
      return sweetalert.fire({ icon: 'error', title: '', text: 'Specimen ID must be at least 8 characters.' })
    }
    let validator = new Validator<any>().withValidation("SubmitterFirstName", Validators.requireNotBlankAndLength(50, "Submitter First Name"));
    if (this.state.selectedSample?.submitterMiddleName && this.state.selectedSample?.submitterMiddleName.trim().length > 0) {
      validator = validator.withValidation("SubmitterMiddleName", Validators.requireNotBlankAndLength(50, "Submitter Middle Name"));
    }
    validator = validator.withValidation("SubmitterLastName", Validators.requireNotBlankAndLength(50, "Submitter Last Name"))
      .withSimpleValidation("Status", Validators.requireNonNullValidator("Status"));
      validator = validator.withComposedValidation("SubmitterPhone", new ValidationEntry(Validators.requireNonNullValidator("Submitter Phone")), new ValidationEntry(Validators.requirePhone("Submitter Phone")))
      validator = validator.withComposedValidation("SubmitterEmail", new ValidationEntry(Validators.requireValidEmail("Submitter Email")), Validators.requireNotBlankAndLength(100, "Submitter Email"))
      validator = validator.withValidation("SubmitterAddress", Validators.requireNotBlankAndLength(500, "Submitter Address"))
      validator = validator.withValidation("SubmitterState", Validators.requireNotBlankAndLength(100, "Submitter State"))
      validator = validator.withValidation("SubmitterCity", Validators.requireNotBlankAndLength(100, "Submitter City"))
      validator = validator.withComposedValidation("SubmitterZip", new ValidationEntry(Validators.requireNotBlankValidator("Submitter Zipcode")), new ValidationEntry(Validators.requireZip("Submitter Zipcode")))
    if (this.state.selectedSample?.rerunCount) {
      validator = validator.withValidation("RerunCount", new ValidationEntry<SampleEdit>((key, attr, obj) => {
        if (isNaN(parseInt(attr))) {
          return { success: false, error: "Rerun Count must be numeric" };
        } else if (attr < 1 || attr > 100) {
          return {
            success: false,
            error: "Rerun Count must be between 1 and 100",
          };
        }
        return { success: true, error: null };
      })
      );
    }
    if (this.state.selectedSample?.reason && this.state.selectedSample?.reason.trim().length > 0) {
      validator = validator.withValidation("Reason", Validators.requireNotBlankAndLength(500, "Result Reason"));
    }
    validator = validator.withSimpleValidation("InternalSpecimenID", Validators.requireNotBlankIfExistsValidator(this.props.selectedSample.InternalSpecimenID, "Internal Specimen ID"));
    if (this.state.selectedSample?.internalSpecimenID && this.state.selectedSample?.internalSpecimenID.trim().length > 0) {
      validator = validator.withValidation("InternalSpecimenID", Validators.requireNotBlankAndLength(50, "Internal Specimen ID"));
    }
    if (this.state.selectedSample?.collectionDate) {
      validator = validator.withComposedValidation("CollectionDate", new ValidationEntry(Validators.requireNotFutureDate("Collection Date")), new ValidationEntry(Validators.requireNotBlankIfExistsValidator(this.props.selectedSample.CollectionDate, "Collection Date")), new ValidationEntry(Validators.requireNotBeforePatientDOB(this.state.selectedSample?.submitterDOB, "Collection Date")));
    }
    if (this.state.selectedSample?.testOrderedDate) {
      validator = validator.withComposedValidation("TestOrderedDate", new ValidationEntry(Validators.requireNotFutureDate("Test Ordered Date")), new ValidationEntry(Validators.requireNotBlankIfExistsValidator(this.props.selectedSample.TestOrderedDate, "Test Ordered Date")), new ValidationEntry(Validators.requireNotBeforePatientDOB(this.state.selectedSample?.submitterDOB, "Test Ordered Date")));
    }
    if (this.state.selectedSample?.processedDate) {
      validator = validator.withComposedValidation("ProcessedDate", new ValidationEntry(Validators.requireNotFutureDate("Processed Date")), new ValidationEntry(Validators.requireNotBeforePatientDOB(this.state.selectedSample?.submitterDOB, "Processed Date")));
    }
    if (this.state.selectedSample?.testResultDate) {
      validator = validator.withComposedValidation("TestResultDate", new ValidationEntry(Validators.requireNotFutureDate("Test Result Date")), new ValidationEntry(Validators.requireNotBeforePatientDOB(this.state.selectedSample?.submitterDOB, "Test Result Date")));
    }
    if (this.state.selectedSample?.reportedDate) {
      validator = validator.withComposedValidation("ReportedDate", new ValidationEntry(Validators.requireNotFutureDate("Reported Date")), new ValidationEntry(Validators.requireNotBeforePatientDOB(this.state.selectedSample?.submitterDOB, "Reported Date")));
    }
    if (this.state.selectedSample?.resultsAccessedDate) {
      validator = validator.withComposedValidation("ResultsAccessedDate", new ValidationEntry(Validators.requireNotFutureDate("Results Accessed Date")), new ValidationEntry(Validators.requireNotBeforePatientDOB(this.state.selectedSample?.submitterDOB, "Results Accessed Date")));
    }

    //TODO: update for multi-tests - if allowing to delete all tests, these will not be needed. leaving this here in case minds change.
    // validator = validator.withSimpleValidation("TestIDs", Validators.requireNotBlankIfExistsValidator(this.props.selectedSample.TestIDs, "Test IDs"))
    // validator = validator.withSimpleValidation("SpecimenSourceID", Validators.requireNotBlankIfExistsValidator(this.props.selectedSample.SpecimenSourceID, "Specimen Source ID"))
    if (this.state.selectedSample.testIDs?.length > 0 && this.state.selectedSample.collectionDate) {
      validator = validator.withSimpleValidation("SpecimenSourceID", Validators.requireNonNullValidator("Specimen Source"));
    }
    validator = 
    validator.withSimpleValidation("Submitting Provider", Validators.requireNotBlankIfExistsValidator(this.props.selectedSample.SubmittingProvider, "Submitting Provider"))
    //   .withSimpleValidation("ProviderLastName", Validators.requireNotBlankIfExistsValidator(this.props.selectedSample.ProviderLastName, "Provider Last Name"))
      .withSimpleValidation("Lot", Validators.requireNotBlankIfExistsValidator(this.props.selectedSample.Lot, "Lot"));
    if (this.state.selectedSample?.memo && this.state.selectedSample?.memo.trim().length > 0) {
      validator = validator.withSimpleValidation("Memo", Validators.requireLength(1000));
    }
    validator = validator.withSimpleValidation("FacilityID", Validators.requireNotBlankIfExistsValidator(this.props.selectedSample.FacilityID, "Facility ID"));
    if (this.state.selectedSample?.onsetSymptomsDate) {
      validator = validator.withComposedValidation("OnsetSymptomsDate", new ValidationEntry(Validators.requireNotFutureDate("Onset Symptoms Date")), new ValidationEntry(Validators.requireNotBeforePatientDOB(this.state.selectedSample?.submitterDOB, "Onset Symptoms Date")));
    }
    validator = validator.withSimpleValidation("InsuredFirstName", Validators.requireNotBlankIfExistsValidator(this.props.selectedSample.InsuredFirstName, "Insured First Name"))
      .withSimpleValidation("InsuredLastName", Validators.requireNotBlankIfExistsValidator(this.props.selectedSample.InsuredLastName, "Insured Last Name"))
      .withSimpleValidation("InsuredDOB", Validators.requireNotBlankIfExistsValidator(this.props.selectedSample.InsuredDOB, "Insured DOB"))
      .withSimpleValidation("InsuredAddressLine1", Validators.requireNotBlankIfExistsValidator(this.props.selectedSample.InsuredAddressLine1, "Insured Address"))
      .withSimpleValidation("InsuredAddressLine2", Validators.requireNotBlankIfExistsValidator(this.props.selectedSample.InsuredAddressLine2, "Insured Address Cont."))
      .withSimpleValidation("InsuredCity", Validators.requireNotBlankIfExistsValidator(this.props.selectedSample.InsuredCity, "Insured City"))
      .withSimpleValidation("InsuredState", Validators.requireNotBlankIfExistsValidator(this.props.selectedSample.InsuredState, "Insured State"))
      .withSimpleValidation("InsuredZip", Validators.requireNotBlankIfExistsValidator(this.props.selectedSample.InsuredZip, "Insured Zip"))
      .withSimpleValidation("InsuredSSN", Validators.requireNotBlankIfExistsValidator(this.props.selectedSample.InsuredSSN, "Insured SSN"))
      .withSimpleValidation("InsuredMRN", Validators.requireNotBlankIfExistsValidator(this.props.selectedSample.InsuredMRN, "Insured MRN"));
    if (this.state.selectedSample?.insuredFirstName && this.state.selectedSample?.insuredFirstName.trim().length > 0) {
      validator = validator.withValidation("InsuredFirstName", Validators.requireNotBlankAndLength(100, "Insured First Name"));
    }
    if (this.state.selectedSample?.insuredLastName && this.state.selectedSample?.insuredLastName.trim().length > 0) {
      validator = validator.withValidation("InsuredLastName", Validators.requireNotBlankAndLength(100, "Insured Last Name"));
    }
    if (this.state.selectedSample?.insuredSSN && this.state.selectedSample?.insuredSSN.trim().length > 0) {
      validator = validator.withValidation("InsuredSSN", Validators.requireNotBlankAndLength(45, "Insured SSN"))
        .withSimpleValidation("InsuredSSN", Validators.requireValidSSN("Insured SSN"));
    }
    if (this.state.selectedSample?.insuredMRN && this.state.selectedSample?.insuredMRN.trim().length > 0) {
      validator = validator.withValidation("InsuredMRN", Validators.requireNotBlankAndLength(45, "Insured MRN"));
    }
    if (this.state.selectedSample?.insuredAddressLine1 && this.state.selectedSample?.insuredAddressLine1.trim().length > 0) {
      validator = validator.withValidation("InsuredAddressLine1", Validators.requireNotBlankAndLength(100, "Insured Address"));
    }
    if (this.state.selectedSample?.insuredCity && this.state.selectedSample?.insuredCity.trim().length > 0) {
      validator = validator.withValidation("InsuredCity", Validators.requireNotBlankAndLength(100, "Insured City"));
    }
    if (this.state.selectedSample?.insuredState) {
      validator = validator.withSimpleValidation("InsuredState", Validators.requireNonNullValidator("Insured State"));
    }
    if (this.state.selectedSample?.insuredZip && this.state.selectedSample?.insuredZip.trim().length > 0) {
      validator = validator.withValidation("InsuredZip", Validators.requireNotBlankAndLength(100, "Insured Zip"))
        .withSimpleValidation("InsuredZip", Validators.requireZip("Insured Zip"));
    }
    if (this.state.selectedSample?.insuredDOB) {
      validator = validator.withValidation("InsuredDOB", Validators.requireDOB(150, "Insured DOB"));
    }

    let validationResponse = validator.validate(this.getEdittedObj());
    if (!validationResponse.success) {
      return sweetalert.fire({
        icon: "error",
        title: "",
        text: validationResponse.error,
      });
    }

    let serviceQuestions = this.props.customQuestions.filter((f) => f.ServiceID && f.ServiceID === this.state.selectedSample?.ServiceID && f.Options.isActive && !f.IsSubmitterField);

    let customFieldDataQuestions = this.props.customFields.filter((f) => !f.ServiceID && f.Options.isActive && !f.IsSubmitterField);

    let invalid = false;

    if (serviceQuestions.length > 0) {
      invalid = CustomFieldBuilder.validateCustomFields(this.state.selectedSample?.CustomFieldData, serviceQuestions, this.getEdittedObj());
    }

    if (invalid) {
      return;
    }

    if (customFieldDataQuestions.length > 0) {
      invalid = CustomFieldBuilder.validateCustomFields(this.state.selectedSample?.CustomFieldData, customFieldDataQuestions, this.getEdittedObj());
    }

    if (invalid) {
      return;
    }

    // //Ranges are stored in this.props.testDetails
    // if(this.state.selectedSample && this.state.selectedSample.testsAndResultsMap && this.state.selectedSample.testsAndResultsMap.length > 0 && this.state.selectedSample.resultIDs && this.state.selectedSample.resultIDs.length > 0){
    //   let resultAllowsNonstandardValue = this.props.result_types.find(r => r.value === this.state.selectedSample.resultIDs[0]).AllowNonStandardResultValue
    //   if(resultAllowsNonstandardValue){
    //     for (let i = 0; i < this.state.selectedSample.testsAndResultsMap.length; i++) {
    //       const testsAndResultsMapElement = this.state.selectedSample.testsAndResultsMap[i];
    //       //if AllowNonStandardResultValue is true for ResultID then check to make sure there is a ResultValue and that it is within range

    //       //for each test get value ranges 
    //       //make sure ResultValue is within ResultID range
    //       // let numValue = Number(testsAndResultsMapElement.ResultValue);
    //       let test = this.props.testDetails.find(t => t.ID === testsAndResultsMapElement.TestID)
    //       // let lowRangeStart = test && test.LowRangeStart ? Number(test.LowRangeStart) : 0;
    //       // let lowRangeEnd = test && test.LowRangeEnd ? Number(test.LowRangeEnd) : isNaN(test.moderateRange) ? 0 : Number(test.moderateRangeStart) - 1;
    //       // let moderateRangeStart = test && test.ModerateRangeStart ? Number(test.ModerateRangeStart) : 0;
    //       // let moderateRangeEnd = test && test.ModerateRangeEnd ? Number(test.ModerateRangeEnd) : Number(test.HighRangeStart) - 1;
    //       // let highRangeStart = test && test.HighRangeStart ? Number(test.HighRangeStart) : 0;
    //       // let highRangeEnd = test && test.HighRangeEnd ? Number(test.HighRangeEnd) : Infinity;

    //       let resultText;
    //       test.ValidResults.map(vr => {
    //         if(vr.ID === testsAndResultsMapElement.ResultID){
    //           resultText = vr.Value
    //         }
    //       })

    //       // if(resultText === 'Not Detected (non-standard)' && numValue > 0){
    //       //   return sweetalert.fire({icon: 'error', title: '', text: `${resultText} result value cannot be greater than 0 for ${test.Name}`})
    //       // }
    //       // else if (resultText === 'Low' && (numValue < lowRangeStart || numValue > lowRangeEnd)) {
    //       //   return sweetalert.fire({icon: 'error', title: '', html: `<h4>${numValue} is outside the ${resultText} range for ${test.Name}</h4> <p>(${lowRangeStart} - ${lowRangeEnd})</p>`})
    //       // } 
    //       // else if (resultText === 'Moderate' && (numValue < moderateRangeStart || numValue > moderateRangeEnd)) {
    //       //   return sweetalert.fire({icon: 'error', title: '', html: `<h4>${numValue} is outside the ${resultText} range for ${test.Name}</h4> <p>(${moderateRangeStart} - ${moderateRangeEnd})</p>`})
    //       // } 
    //       // else if (resultText === "High" && (numValue < highRangeStart || numValue > highRangeEnd)) {
    //       //   return sweetalert.fire({icon: 'error', title: '', html: `<h4>${numValue} is outside the ${resultText} range result for ${test.Name}</h4> <p>(${highRangeStart} - ${highRangeEnd})</p>`})
    //       // } 

    //     }
    //   }
    // }


    //make sure ResultValue is present and numerical for results that have AllowNonStandardResultValue = 1
    if (this.state.selectedSample && this.state.selectedSample.testsAndResultsMap && this.state.selectedSample.testsAndResultsMap.length > 0 && this.state.selectedSample.resultIDs && this.state.selectedSample.resultIDs.length > 0) {
      let resultAllowsNonstandardValue = this.props.result_types.find(r => r.value === this.state.selectedSample.resultIDs[0]).AllowNonStandardResultValue
      if (resultAllowsNonstandardValue) {
        let resultIDsThatAllowNonStandardResultValues = this.props.result_types.filter(f => f.AllowNonStandardResultValue).map(r => { return r.value })
        for (let i = 0; i < this.state.selectedSample.testsAndResultsMap.length; i++) {
          const testsAndResultsMapElement = this.state.selectedSample.testsAndResultsMap[i];
          if (resultIDsThatAllowNonStandardResultValues.includes(testsAndResultsMapElement.ResultID)) {
            if (!testsAndResultsMapElement.ResultValue && testsAndResultsMapElement.ResultValue !== 0) {
              return sweetalert.fire({
                icon: "error",
                title: "",
                text: `Please verify Result Value provided for ${getNameFromID(testsAndResultsMapElement.TestID, this.props.testDetails)}`
              })
            }
            if (isNaN(testsAndResultsMapElement.ResultValue)) {
              return sweetalert.fire({
                icon: "error",
                title: "",
                text: `Result Value is not a number for ${getNameFromID(testsAndResultsMapElement.TestID, this.props.testDetails)}`
              })
            }
          }
        }
      }
    }

    this.setState({ submitClicked: true });
    this.editSample();
  }

  editSample() {
    let sampleInfo = {
      ID: this.state.selectedSample?.sampleID,
      submitterPortalUID: this.state.selectedSample?.submitterID ? this.state.selectedSample?.submitterPortalUID.trim() : null,
      LinkedApptsID: this.state.selectedSample?.linkedApptsID ? this.state.selectedSample?.linkedApptsID.trim() : null,
      ReqNum: this.state.selectedSample?.reqNum ? this.state.selectedSample?.reqNum.trim() : null,
      SpecimenID: this.state.selectedSample?.specimenID ? this.state.selectedSample?.specimenID.trim() : null,
      InternalSpecimenID: this.state.selectedSample?.internalSpecimenID ? this.state.selectedSample?.internalSpecimenID.trim() : null,
      Memo: this.state.selectedSample?.memo ? this.state.selectedSample?.memo.trim() : null,
      AnimalType: this.state.selectedSample?.animalType ? this.state.selectedSample?.animalType : null,
      SubmitterID: this.state.selectedSample?.submitterID ? this.state.selectedSample?.submitterID : null,
      SubmitterFirstName: this.state.selectedSample?.submitterFirstName ? this.state.selectedSample?.submitterFirstName.trim() : null,
      SubmitterLastName: this.state.selectedSample?.submitterLastName ? this.state.selectedSample?.submitterLastName.trim() : null,
      SubmitterZip: this.state.selectedSample?.submitterZip ? this.state.selectedSample?.submitterZip.trim() : null,
      SubmitterCity: this.state.selectedSample?.submitterCity ? this.state.selectedSample?.submitterCity.trim() : null,
      SubmitterState: this.state.selectedSample?.stateLabel ? this.state.selectedSample?.stateLabel.value : null,
      SubmitterAddress: this.state.selectedSample?.submitterAddress ? this.state.selectedSample?.submitterAddress.trim() : null,
      SubmitterEmail: this.state.selectedSample?.submitterEmail ? this.state.selectedSample?.submitterEmail.trim() : null,
      SubmitterPhone: this.state.selectedSample?.submitterPhone ? this.state.selectedSample?.submitterPhone.trim() : null,
      // ProviderFirstName: this.state.selectedSample?.providerFirstName ? this.state.selectedSample?.providerFirstName.trim() : null,
      // ProviderLastName: this.state.selectedSample?.providerLastName ? this.state.selectedSample?.providerLastName.trim() : null,
      SampleReceivedID: this.state.selectedSample?.binID ? this.state.selectedSample?.bin.value.ID : null,
      BatchID: this.state.selectedSample?.batchNum ? this.state.selectedSample?.batchNums.value.ID : null,
      WellSlot: this.state.selectedSample?.wellSlot ? this.state.selectedSample?.wellSlot.trim() : null,
      CollectionDate: getDateOrNull(this.state.selectedSample?.collectionDate),
      SpecimenSourceID: this.state.selectedSample?.specimenSourceID ? this.state.selectedSample?.specimenSourceID : null,
      TestIDs: this.state.selectedSample?.testIDs ? this.state.selectedSample?.testIDs : null,
      ProcessedDate: getDateOrNull(this.state.selectedSample?.processedDate),
      TestOrderedDate: getDateOrNull(this.state.selectedSample?.testOrderedDate),
      ApptTime: this.state.selectedSample?.apptTime ? moment(this.state.selectedSample?.apptTime, "hh:mm a").format("hh:mm a") : null,
      PodApptID: this.state.selectedSample?.podLabel ? this.state.selectedSample?.podLabel.value : null,
      ApptCanceled: this.state.selectedSample?.apptCanceledLabel ? this.state.selectedSample?.apptCanceledLabel.value : null,
      RerunCount: this.state.selectedSample?.rerunCount ? this.state.selectedSample?.rerunCount : null,
      RerunFlag: this.state.selectedSample?.rerunFlagLabel ? this.state.selectedSample?.rerunFlagLabel.value : null,
      ConsentFlag: this.state.selectedSample?.consentFlagLabel ? this.state.selectedSample?.consentFlagLabel.value : null,
      ResultIDs: this.state.selectedSample?.resultIDs ? this.state.selectedSample?.resultIDs : null,
      Reason: this.state.selectedSample?.reason ? this.state.selectedSample?.reason.trim() : null,
      TestResultDate: getDateOrNull(this.state.selectedSample?.testResultDate),
      ReportedDate: getDateOrNull(this.state.selectedSample?.reportedDate),
      CreatedDate: getDateOrNull(this.state.selectedSample?.createdDate),
      FacilityID: this.state.selectedSample?.facilityID ? this.state.selectedSample?.facilityName.value : null,
      ResultsAccessedDate: getDateOrNull(this.state.selectedSample?.resultsAccessedDate),
      Lot: this.state.selectedSample?.lot ? this.state.selectedSample?.lot.trim() : null,
      CustomFieldData: this.state.selectedSample?.CustomFieldData ? this.state.selectedSample?.CustomFieldData : null,
      IncludeInHL7: this.state.selectedSample?.IncludeInHL7 ? this.state.selectedSample.IncludeInHL7 : null,
      TestsAndResultsMap: this.state.selectedSample?.testsAndResultsMap ? this.state.selectedSample?.testsAndResultsMap : null,
      FileUploadPaths: this.state.selectedSample?.fileNames ? this.state.selectedSample?.fileNames : null,
      Status: this.state.selectedSample?.statusLabel ? this.state.selectedSample?.statusLabel.value : null,
      RabiesExposureInfo: this.state.selectedSample?.RabiesExposureInfo ? this.state.selectedSample?.RabiesExposureInfo : null,
      SubmitterContactID: this.state.selectedSample?.SubmitterContactID ? this.state.selectedSample?.SubmitterContactID : null,
      SubmittingProvider: this.state.selectedSample?.SubmittingProvider ? this.state.selectedSample?.SubmittingProvider : null,
    };
    let insuranceInfo = {
      FirstName: this.state.selectedSample?.insuredFirstName ? this.state.selectedSample?.insuredFirstName.trim() : null,
      LastName: this.state.selectedSample?.insuredLastName ? this.state.selectedSample?.insuredLastName.trim() : null,
      SSN: this.state.selectedSample?.insuredSSN ? this.state.selectedSample?.insuredSSN.replace(/-/g, "").trim() : null,
      DOB: getDateOrNull(this.state.selectedSample?.insuredDOB),
      MRN: this.state.selectedSample?.insuredMRN ? this.state.selectedSample?.insuredMRN.trim() : null,
      AddressLine1: this.state.selectedSample?.insuredAddressLine1 ? this.state.selectedSample?.insuredAddressLine1.trim() : null,
      AddressLine2: this.state.selectedSample?.insuredAddressLine2 ? this.state.selectedSample?.insuredAddressLine2.trim() : null,
      City: this.state.selectedSample?.insuredCity ? this.state.selectedSample?.insuredCity.trim() : null,
      State: this.state.selectedSample?.insuredStateLabel ? this.state.selectedSample?.insuredStateLabel.value : null,
      Zip: this.state.selectedSample?.insuredZip ? this.state.selectedSample?.insuredZip.trim() : null,
      FrontCard: this.state.selectedSample.insuredFrontCard ? this.state.selectedSample.insuredFrontCard : null,
      BackCard: this.state.selectedSample.insuredBackCard ? this.state.selectedSample.insuredBackCard : null,
    };
    let insuranceCards = this.state.frontCardImgFile ? [this.state.frontCardImgFile, this.state.backCardImgFile] : null

    if (this.state.imageCached) {
      this.setState({ imageCached: false });
    }
    this.setState({ showLoading: true }, async () => {
      hideModal(AnimalSamplesModal.ID);
      try {
        let result = await AnimalSamplesAPI.updateSample(sampleInfo, insuranceInfo, insuranceCards, this.state.selectedFiles);
        if (!result.success) {
          sweetalert.fire({ icon: "error", title: "", text: result.reason });
          this.setState({ submitClicked: false, showLoading: false });
        } else {
          sweetalert.fire({
            icon: "success",
            title: "",
            text: "Sample has been updated.",
          });
          this.setState({ submitClicked: false, showLoading: false });
          this.clearFiles();
          this.props.onSubmit(result.data?.reportsGenerating);
        }
      } catch (e) {
        // console.log(e);
        sweetalert.fire({ icon: "error", title: "", text: "Server error" });
        this.setState({ submitClicked: false, showLoading: false });
      }
    });
  }


  physicianReview() {
    if (!this.state.selectedSample || ((!this.state.selectedSample.submitterPhone || this.state.selectedSample.submitterPhone.length < 1) && (!this.state.selectedSample.submitterEmail || this.state.selectedSample.submitterEmail.length < 1))) {
      return sweetalert.fire({ icon: 'error', title: '', text: 'No submitter phone number and email found. Results cannot be sent.' })
    }
    if (!this.state.selectedSample || !this.state.selectedSample.submitterPhone || this.state.selectedSample.submitterPhone.length < 1) {
      return sweetalert.fire({ icon: 'error', title: '', text: 'No submitter phone number found. Results cannot be sent.' })
    }
    if (!this.state.selectedSample || !this.state.selectedSample.submitterEmail || this.state.selectedSample.submitterEmail.length < 1) {
      return sweetalert.fire({ icon: 'error', title: '', text: 'No submitter email found. Results cannot be sent.' })
    }
    if (this.state.emailOrPhoneChange) {
      return sweetalert.fire({ icon: 'error', title: '', text: 'Submitter information has changed. Sample must be updated before results can be sent.' })
    }

    sweetalert
      .fire({
        title: "Are you sure you want to send results to submitter?",
        showCloseButton: true,
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Yes, send results.",
        denyButtonText: `No`,
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          this.setState({ showLoadingForPhysicianReview: true })
          try {
            //send results to submitter button
            let response = await SamplesAPI.resultsReviewedSendPatientEmail(this.state.selectedSample.sampleID);
            if (response.success) {
              this.setState({ showLoadingForPhysicianReview: false })
              hideModal(AnimalSamplesModal.ID)
              this.props.onSubmit();
              return sweetalert.fire({
                icon: "success",
                title: "",
                text: "Results sent to submitter",
              });
            }
            else {
              this.setState({ showLoadingForPhysicianReview: false })
              return sweetalert.fire({
                icon: "error",
                title: "",
                text: "Could not send results at this time",
              });
            }
          } catch (error) {
            this.setState({ showLoadingForPhysicianReview: false })
            return sweetalert.fire({
              icon: "error",
              title: "",
              text: "Could not send results at this time",
            });
          }
        }
        else {
          return
        }
      })
  }

  // getPhysicianReviewButton(){
  //   if(this.state.selectedSample.resultsReviewed){
  //     return(
  //       <>
  //         <AiOutlineCheckCircle className={"ml-2"} color={"#14410B"} size={30} />
  //         <span className={"ml-1 text-success"} style={{ fontSize: "1em", fontWeight: 'bold' }} > Provider Review Complete </span>
  //       </>
  //     )
  //   }
  //   else if(this.props.getPhysicianReviewButtonBoolean && !this.state.selectedSample.resultsReviewed && this.state.selectedSample.resultApprovedDate){
  //     return (
  //       <button
  //         type="button"
  //         className={"btn btn-info text-white mr-3"}
  //         onClick={() => this.physicianReview()}
  //       >
  //         Send Results to Submitter
  //       </button>
  //     )
  //   }
  //   else{
  //     return <div className="d-none"></div>
  //   }
  // }

  getLinks(service) {
    if (!this.props.selectedSample || !this.props.selectedSample.ReqNum) {
      return null;
    }
    return (
      <div className="card-footer mb-2 mr-2 ml-0" style={{ backgroundColor: "transparent", borderTop: "none" }} >
        <button type="button"
          onClick={() => { this.openDocuments() }}
          className={"btn btn-success mr-3"}
        > Documents </button>
        {/* {this.getPhysicianReviewButton()} */}
        <button disabled={this.state.submitClicked} className={"btn btn-primary  "} style={{ float: "right" }} onClick={() => this.onSubmit()} > Update Sample </button>
      </div>
    );
  }

  getInsuranceCardImagesFromCloud() {
    if (this.state.imageCached) {
      this.setState({ showInBetween: true });
      showModalNoOutsideClick(SampleInsuranceCardModal.ID);
    } else {
      this.setState({ showLoadingForViewInsuranceCards: true }, async () => {
        try {
          let frontImage = await SamplesAPI.downloadFilesFromCloud({
            url: this.state.selectedSample?.insuredFrontCard,
            side: "front",
            ReqNum: this.state.selectedSample?.reqNum,
            type: 'insurance'
          });
          if (typeof frontImage === "object") {
            sweetalert.fire({
              icon: "error",
              title: "",
              text: "Insurance Card Images not found",
            });
            this.setState({ showLoadingForViewInsuranceCards: false });
            return;
          } else {
            this.setState({ frontInsuranceCardImage: frontImage });
          }
          let backImage = await SamplesAPI.downloadFilesFromCloud({
            url: this.state.selectedSample?.insuredBackCard,
            side: "back",
            ReqNum: this.state.selectedSample?.reqNum,
            type: 'insurance'
          });
          if (typeof backImage === "object") {
            sweetalert.fire({
              icon: "error",
              title: "",
              text: "Insurance Card Images not found",
            });
            this.setState({ showLoadingForViewInsuranceCards: false });
            return;
          } else {
            this.setState({
              backInsuranceCardImage: backImage,
              showInBetween: true,
              showLoadingForViewInsuranceCards: false,
              imageCached: true,
            });
            showModalNoOutsideClick(SampleInsuranceCardModal.ID);
          }
        } catch (e) {
          // console.log(e);
          sweetalert.fire({
            icon: "error",
            title: "",
            text: "Error getting Insurance Card Images",
          });
          this.setState({ showLoadingForViewInsuranceCards: false });
        }
      });
    }
  }

  sampleInsuranceCardUpload() {
    if (!isMobile) {
      sweetalert
        .fire({
          title: "Add New Insurance Card Images",
          showCloseButton: true,
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: "Upload",
          denyButtonText: `Capture`,
        })
        .then((result) => {
          this.setState({ showInBetween: true });
          if (result.isConfirmed) {
            showModalNoOutsideClick(InsuranceCardUploadModal.ID);
          } else if (result.isDenied) {
            this.setState({ captureClicked: true });
            showModalNoOutsideClick(InsuranceImageModal.ID);
          } else if (result.isDismissed) {
            this.setState({ showInBetween: false });
          }
        });
    } else {
      this.setState({ showInBetween: true });
      showModalNoOutsideClick(InsuranceCardUploadModal.ID);
    }
  }

  onUpload = (state, e) => {
    if (e.target) {
      this.setState({ [state]: e.target.files[0] } as any);
    } else {
      this.setState({ [state]: e } as any);
    }
  };

  clearFiles = () => {
    const frontUpload = document.querySelector("#FrontCardCapture") as any;
    frontUpload.value = "";
    const backUpload = document.querySelector("#BackCardCapture") as any;
    backUpload.value = "";
    this.setState({ frontCardImgFile: null, backCardImgFile: null, imageSaved: false, selectedFiles: [] });
  };

  addDashes(e, stateToSet) {
    const len = e.target.value.length;
    if (len === 3 || len === 6) {
      e.preventDefault();
      this.setState((prevState) => ({
        selectedSample: {
          ...prevState.selectedSample,
          [stateToSet]: `${e.target.value}-${e.data}`,
        },
      }));
    }
  }

  handleChange(e, stateToSet, stateLabelToSet = '', type = 'input') {
    if (type === 'select') {
      if (stateToSet === "batchNum") {
        this.handleBatch(e, stateLabelToSet, stateToSet)
      }
      else if (stateToSet === "binID") {
        this.handleBinID(e, stateLabelToSet, stateToSet)
      }
      else {
        this.setState((prevState) => ({
          selectedSample: {
            ...prevState.selectedSample,
            [stateLabelToSet]: e,
            [stateToSet]: e.value,
          },
        }));
      }
    }
    else {
      if (stateToSet === "submitterEmail" || stateToSet === "submitterPhone") {
        this.setState({ emailOrPhoneChange: true })
      }
      this.setState((prevState) => ({
        selectedSample: {
          ...prevState.selectedSample,
          [stateToSet]: e.target.value,
        },
      }));
    }

  }

  handleTestChange(e, type, st?) {
    if (type === 'single') {
      this.setState(
        (prevState) => ({
          selectedSample: {
            ...prevState.selectedSample,
            testIDs: [e.value],
            testsAndResultsMap: null,
            specimenSourceID: null,
            specimenSource: null,
            resultIDs: null,
          },
        })
      );
    }
    else {
      let testIDsArray = JSON.parse(JSON.stringify(this.state.selectedSample.testIDs));
      let idToReplace = testIDsArray.indexOf(st.value);
      if (idToReplace !== -1) { testIDsArray.splice(idToReplace, 1, e.value); }
      let resultIDsArray = [];
      let testsAndRusultsMap = JSON.parse(JSON.stringify(this.state.selectedSample.testsAndResultsMap));
      if (testsAndRusultsMap && testsAndRusultsMap.length > 0) {
        let idToReplaceForMap = testsAndRusultsMap.findIndex((f) => f.TestID === st.value);
        if (idToReplaceForMap !== -1) {
          testsAndRusultsMap.splice(
            idToReplaceForMap,
            1
          );
        }
        testsAndRusultsMap.map((t) => {
          return resultIDsArray.push(
            t.ResultID
          );
        }
        );
      }
      let duplicates = testIDsArray.filter((currentValue, currentIndex) => testIDsArray.indexOf(currentValue) !== currentIndex);
      if (duplicates.length > 0) {
        return sweetalert.fire({ icon: "error", title: "", text: "Test must not be duplicated.", });
      }
      this.setState(
        (prevState) => ({
          selectedSample: {
            ...prevState.selectedSample,
            testIDs: testIDsArray,
            testsAndResultsMap: testsAndRusultsMap,
            specimenSourceID: null,
            specimenSource: null,
            resultIDs: resultIDsArray,
          },
        })
      );

    }
  }

  handleResultChange(e, type, st?, index?, selectedTestLabels?) {
    if (type === 'single') {
      this.setState(
        (prevState) => ({
          selectedSample: {
            ...prevState.selectedSample,
            resultIDs: [e.value],
            testsAndResultsMap: [{ TestID: selectedTestLabels[0].value, ResultID: e.value, ResultValue: this.state.selectedSample && this.state.selectedSample.testsAndResultsMap ? this.state.selectedSample.testsAndResultsMap[0].ResultValue : null }],
          },
        })
      );
    }
    else {
      let testsAndResultsMapCopy = this.state.selectedSample && this.state.selectedSample.testsAndResultsMap ? JSON.parse(JSON.stringify(this.state.selectedSample.testsAndResultsMap)) : null;
      let resultIDsCopy = this.state.selectedSample && this.state.selectedSample.resultIDs ? JSON.parse(JSON.stringify(this.state.selectedSample.resultIDs)) : null;
      let resultIDToBeChanged;
      let indexOfTestBeingChanged = -1;
      if (!Array.isArray(testsAndResultsMapCopy)) {
        testsAndResultsMapCopy =
          [];
      }
      if (!Array.isArray(resultIDsCopy)) {
        resultIDsCopy = [];
      }
      if (testsAndResultsMapCopy?.length > 0) {
        for (let i = 0; i < testsAndResultsMapCopy.length; i++) {
          if (testsAndResultsMapCopy[i].TestID === st.value) {
            indexOfTestBeingChanged = i;
            resultIDToBeChanged = testsAndResultsMapCopy[i].ResultID;
            break;
          }
        }
        if (indexOfTestBeingChanged === -1) {
          testsAndResultsMapCopy.push({ TestID: st.value, ResultID: e.value, });
          resultIDsCopy.push(e.value);
        } else {
          testsAndResultsMapCopy.splice(indexOfTestBeingChanged, 1, { TestID: st.value, ResultID: e.value, ResultValue: this.state.selectedSample && this.state.selectedSample.testsAndResultsMap ? this.state.selectedSample.testsAndResultsMap[indexOfTestBeingChanged].ResultValue : null });
          let indexOfResultToBeChanged = -1;
          for (let i = 0; i < resultIDsCopy.length; i++) {
            if (resultIDsCopy[i] === resultIDToBeChanged) {
              indexOfResultToBeChanged = i;
              break;
            }
          }
          resultIDsCopy.splice(indexOfResultToBeChanged, 1, e.value);
        }
      } else {
        testsAndResultsMapCopy.push({ TestID: st.value, ResultID: e.value, });
        resultIDsCopy.push(e.value);
      }
      this.setState(
        (prevState) => ({
          selectedSample: {
            ...prevState.selectedSample,
            resultIDs: resultIDsCopy,
            testsAndResultsMap: testsAndResultsMapCopy,
          },
        })
      );
    }
  }

  handleResultValueChange(e, type, st?) {
    if (type === 'single') {
      let testsAndResultsMapCopy = JSON.parse(JSON.stringify(this.state.selectedSample?.testsAndResultsMap));
      testsAndResultsMapCopy.splice(0, 1, e.target.value.length === 0 ? testsAndResultsMapCopy[0] = { TestID: testsAndResultsMapCopy[0].TestID, ResultID: testsAndResultsMapCopy[0].ResultID } : { ...testsAndResultsMapCopy[0], ResultValue: e.target.value });
      this.setState(
        (prevState) => ({
          selectedSample:
          {
            ...prevState.selectedSample,
            testsAndResultsMap: testsAndResultsMapCopy,
          },
        })
      );
    }
    else {
      let testsAndResultsMapCopy = JSON.parse(JSON.stringify(this.state.selectedSample?.testsAndResultsMap));
      let indexOfTestBeingChanged = -1;
      if (!Array.isArray(testsAndResultsMapCopy)) {
        testsAndResultsMapCopy = [];
      }
      if (testsAndResultsMapCopy?.length > 0) {
        for (let i = 0; i < testsAndResultsMapCopy.length; i++) {
          if (testsAndResultsMapCopy[i].TestID === st.value) {
            indexOfTestBeingChanged = i;
            break;
          }
        }
        if (indexOfTestBeingChanged === -1) {
          return;
        } else {
          testsAndResultsMapCopy.splice(indexOfTestBeingChanged, 1, e.target.value.length === 0 ? testsAndResultsMapCopy[indexOfTestBeingChanged] = { TestID: testsAndResultsMapCopy[indexOfTestBeingChanged].TestID, ResultID: testsAndResultsMapCopy[indexOfTestBeingChanged].ResultID } : { ...testsAndResultsMapCopy[indexOfTestBeingChanged], ResultValue: e.target.value });
        }
      }
      this.setState(
        (prevState) => ({
          selectedSample:
          {
            ...prevState.selectedSample,
            testsAndResultsMap: testsAndResultsMapCopy,
          },
        })
      );
    }
  }

  handleDateOnChange(value, state) {
    // console.log(" handleDateOnChange value ", value, " state ", state);

    if (value) {
      this.setState((prevState) => ({
        selectedSample: {
          ...prevState.selectedSample,
          [state]: value,
        },
      }));
    } else {
      this.setState((prevState) => ({
        selectedSample: {
          ...prevState.selectedSample,
          [state]: null,
        },
      }));
    }
  }

  handleBatch(event, stateLabelToSet, stateToSet) {
    this.setState((prevState) => ({
      selectedSample: {
        ...prevState.selectedSample,
        [stateLabelToSet]: event,
        [stateToSet]: event.value,
        resultApprovedDate: new Date(event.value.ResultApprovedDate),
      },
    }));
  }

  handleBinID(event, stateLabelToSet, stateToSet) {
    this.setState((prevState) => ({
      selectedSample: {
        ...prevState.selectedSample,
        [stateLabelToSet]: event,
        [stateToSet]: event.value,
        receivedBy: event.value.ReceivedBy,
        receivedDate: new Date(event.value.ReceivedDate),
      },
    }));
  }

  disableCollectionRelevantFields(field) {
    if (!this.props.selectedSample[field] && !this.props.isGlobal) {
      return true;
    }
    return false;
  }

  getResultOptions(testID) {
    //go through testDetails for this test and display valid test results options
    let resultOptions = [];
    if (this.props.testDetails?.length > 0) {
      let temp = this.props.testDetails.find((td) => td.ID === testID);
      if (temp && temp.ValidResults?.length > 0) {
        for (let i = 0; i < temp.ValidResults.length; i++) {
          resultOptions.push({
            label: temp.ValidResults[i].Value,
            value: temp.ValidResults[i].ID,
          });
        }
      }
    }
    return resultOptions;
  }

  getSelectedResultValue(testID) {
    //get resultID for selected test and display
    let testsAndResultsMap = this.state.selectedSample?.testsAndResultsMap ? JSON.parse(JSON.stringify(this.state.selectedSample.testsAndResultsMap)) : [];
    let resultID;
    if (testsAndResultsMap && testsAndResultsMap.length > 0) {
      let temp = testsAndResultsMap.find((t) => t.TestID === testID);
      resultID = temp ? temp.ResultID : null;
    }
    if (resultID) {
      // let temp = this.props.testDetails.find((td) => td.ID === testID);
      // let selectedResult = temp.ValidResults.find((v) => v.ID === resultID);

      let selectedResult = this.props.result_types.find(r => r.value === resultID)

      return selectedResult ? { label: selectedResult.label, value: selectedResult.value } : null;
    } else {
      return null;
    }
  }

  getSelectedResultNonStandardValue(testID) {
    let testsAndResultsMap = this.state.selectedSample?.testsAndResultsMap ? JSON.parse(JSON.stringify(this.state.selectedSample.testsAndResultsMap)) : [];
    let resultValue;
    if (testsAndResultsMap && testsAndResultsMap.length > 0) {
      let temp = testsAndResultsMap.find((t) => t.TestID === testID);
      resultValue = temp ? temp.ResultValue : null;
    }

    return resultValue;
  }

  resultHasNonStandardResult(testID) {
    let hasAdditionalResultValue = false;

    let resultsThatAllowNonStandard = this.props.result_types.filter((r) => r.AllowNonStandardResultValue);
    resultsThatAllowNonStandard = resultsThatAllowNonStandard.map((r) => {
      return r.value;
    });

    let testsAndResultsMap = this.state.selectedSample?.testsAndResultsMap ? JSON.parse(JSON.stringify(this.state.selectedSample.testsAndResultsMap)) : [];

    let temp = testsAndResultsMap.find((t) => t.TestID === testID);

    if (resultsThatAllowNonStandard.includes(temp.ResultID)) {
      hasAdditionalResultValue = true;
    }

    return hasAdditionalResultValue;
  }

  async handleAddNewTest(options) {
    const { value: newTest } = await sweetalert.fire({
      title: "Add Test",
      input: "select",
      inputOptions: options.map((t) => {
        return t.label;
      }),
      inputPlaceholder: "Select test",
      showCancelButton: true,
      confirmButtonText: "Add",
      inputValidator: (value) => {
        if (!value || isBlank(value) || isOnlyWhitespace(value)) {
          return "A test must be selected";
        }
      },
    });
    if (newTest) {
      let testIDsCopy = JSON.parse(JSON.stringify(this.state.selectedSample.testIDs));
      if (Array.isArray(testIDsCopy)) {
        testIDsCopy.push(options[newTest].value);
      } else {
        testIDsCopy = [options[newTest].value];
      }

      let duplicates = testIDsCopy.filter((currentValue, currentIndex) => testIDsCopy.indexOf(currentValue) !== currentIndex);

      if (duplicates && duplicates.length > 0) {
        return sweetalert.fire({
          icon: "error",
          title: "",
          text: "Test must not be duplicated.",
        });
      }
      this.setState((prevState) => ({
        selectedSample: {
          ...prevState.selectedSample,
          testIDs: testIDsCopy,
          specimenSourceID: null,
          specimenSource: null,
        },
      }));
    }
  }

  removeTest(testID, isSingleTest = false) {
    sweetalert
      .fire({
        html: `<p style="margin-top: 1rem; padding-left: 1rem; padding-right: 1rem; font-weight: bold"> ${getLabel(testID, this.props.tests).label
          }</p><p> Confirm removal of this test?</p ><p><span style="font-weight: bold">NOTE: </span>Test will not be removed until sample is updated.</p>`,
        showCloseButton: false,
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Remove Test",
        denyButtonText: "Cancel",
      })
      .then((result) => {
        if (result.isConfirmed) {
          if (!isSingleTest) {
            //remove testID from testIDs array and from testsAndResultsObj
            let testIDsCopy = JSON.parse(JSON.stringify(this.state.selectedSample.testIDs));
            let filteredTestIDs = testIDsCopy.filter((t) => t !== testID);
            let testsAndResultsMapCopy = this.state.selectedSample.testsAndResultsMap ? JSON.parse(JSON.stringify(this.state.selectedSample.testsAndResultsMap)) : null;
            let filteredTestsAndResultsMap = [];
            let resultIDsCopy = this.state.selectedSample.resultIDs ? JSON.parse(JSON.stringify(this.state.selectedSample.resultIDs)) : null;
            if (filteredTestIDs.length < 1) {
              filteredTestIDs = null;
              testsAndResultsMapCopy = null;
              resultIDsCopy = null;
            } else if (testsAndResultsMapCopy && testsAndResultsMapCopy.length > 0) {
              testsAndResultsMapCopy.map((t) => {
                if (t.TestID === testID) {
                  let indexToRemove = resultIDsCopy.indexOf(t.ResultID);
                  if (indexToRemove !== -1) {
                    resultIDsCopy.splice(indexToRemove, 1);
                  }
                }
              });
              filteredTestsAndResultsMap = filteredTestsAndResultsMap.concat(testsAndResultsMapCopy.filter((t) => t.TestID !== testID));
            }

            this.setState((prevState) => ({
              selectedSample: {
                ...prevState.selectedSample,
                testIDs: filteredTestIDs,
                testsAndResultsMap:
                  filteredTestsAndResultsMap.length > 0 ? filteredTestsAndResultsMap : testsAndResultsMapCopy,
                resultIDs: resultIDsCopy,
                specimenSourceID: null,
                specimenSource: null,
              },
            }));
          }
          //isSingleTest is true
          else {
            this.setState((prevState) => ({
              selectedSample: {
                ...prevState.selectedSample,
                testIDs: null,
                resultIDs: null,
                testsAndResultsMap: null,
                specimenSource: null,
                specimenSourceID: null,
              },
            }));
          }
        } else {
          return;
        }
      });
  }

  onDrop = (files) => {
    let combinedFileNames = [];
    combinedFileNames = this.state.selectedSample?.fileNames ? combinedFileNames.concat(this.state.selectedSample.fileNames) : [];
    let newFileName = files[0].name.replace(/\s+/g, '');
    combinedFileNames.push(newFileName)

    //check for duplicate
    const seen = new Set();
    const duplicates = combinedFileNames.filter(item => seen.size === seen.add(item).size);
    if (duplicates && duplicates.length > 0) {
      return sweetalert.fire('', `<b>${duplicates[0]}</b> already selected`, 'error')
    }

    //update state
    this.setState((prevState) => ({
      //add file to selectedFiles
      selectedFiles: [...prevState.selectedFiles, files[0]],
      //add name to this.state.selectedSample.fileNames
      selectedSample: {
        ...prevState.selectedSample,
        fileNames: [...prevState.selectedSample.fileNames, newFileName]
      }
    }))
  };

  removeFile = (fileName) => {

    sweetalert.fire({
      showCancelButton: false,
      showConfirmButton: true,
      showDenyButton: true,
      denyButtonColor: 'green',
      denyButtonText: 'Cancel',
      confirmButtonText: 'Delete',
      confirmButtonColor: '#C31230',
      title: '',
      html: `<h5>Are you sure you want to delete <b>${fileName}</b>?</h5>`,
      icon: 'warning'
    })
      .then((result) => {
        if (result.isDenied) {
          return
        }
        else {
          let fileNamesCopy = this.state.selectedSample && this.state.selectedSample.fileNames && this.state.selectedSample.fileNames.length > 0 ? JSON.parse(JSON.stringify(this.state.selectedSample.fileNames)) : null;

          let indexToRemove = fileNamesCopy.indexOf(fileName);
          if (indexToRemove >= 0) {
            fileNamesCopy.splice(indexToRemove, 1)
          }

          let selectedFilesCopy = this.state.selectedFiles && this.state.selectedFiles.length > 0 ? this.state.selectedFiles : [];

          if (selectedFilesCopy) {
            let indexToRemoveFile = selectedFilesCopy.findIndex(file => file.name.replace(/\s+/g, '') === fileName);

            if (indexToRemoveFile >= 0) {
              selectedFilesCopy.splice(indexToRemoveFile, 1)
            }

          }

          this.setState((prevState) => ({
            selectedFiles: selectedFilesCopy,
            selectedSample: {
              ...prevState.selectedSample,
              fileNames: fileNamesCopy
            }
          }))
        }
      })


  }

  downloadFile = async (name) => {
    this.setState({ showInBetween: true })
    let file = await SamplesAPI.downloadFilesFromCloud({ ReqNum: this.state.selectedSample?.reqNum, fileName: name })
    try {
      if (typeof file === "object") {
        sweetalert.fire({
          icon: "error",
          title: "",
          text: "File not found",
        });
        this.setState({ showInBetween: false });
        return;
      } else {
        const link = document.createElement("a");
        link.href = file;
        link.download = `${name}`;
        link.click();
        this.setState({ showInBetween: false })
      }
    } catch (error) {
      console.error('error downloading file', error)
      this.setState({ showInBetween: false })
      return sweetalert.fire({ icon: 'error', title: '', text: 'Could not download file. Please try again.' })
    }
  }

  // Lets the user pick documents (requisition and STARLIMS reports) and opens them as one merged PDF.
  async openDocuments() {
    const reqNum = this.props.selectedSample?.ReqNum || this.state.selectedSample?.reqNum;
    if (!reqNum) {
      return sweetalert.fire({ icon: 'error', title: '', text: 'No requisition number found for this sample.' });
    }
    const documentTypes = await promptDocumentSelection(`Documents - ${reqNum}`);
    if (!documentTypes) {
      return;
    }
    this.setState({ showLoading: true });
    await downloadSampleDocuments([reqNum], documentTypes);
    this.setState({ showLoading: false });
  }

  handleRabiesExposureUpdate(e, key, index) {
    let currentInfo = this.state.selectedSample.RabiesExposureInfo;
    currentInfo[index][key] = e;

    this.setState({
      selectedSample: {
        ...this.state.selectedSample,
        RabiesExposureInfo: currentInfo
      }
    }
    )
  }

  render():
    | React.ReactElement
    | string
    | number
    | {}
    | React.ReactNodeArray
    | React.ReactPortal
    | boolean
    | null
    | undefined {

    // console.log('SamplesModal state', this.state)


    let pods = [];
    this.props.pods.map(p => {
      return p.options.map(o => {
        return pods.push({ label: o.label, value: o.value.ID })
      })
    })

    let serviceQuestions = this.props.customQuestions
      ? this.props.customQuestions.filter((f) => f.ServiceID && f.ServiceID === this.state.selectedSample?.ServiceID && f.Options.isActive && !f.IsSubmitterField) : [];
    let customFieldDataQuestions = this.props.customFields ? this.props.customFields : [];
    let customSubmitterFields = this.props.customSubmitterFields ? this.props.customSubmitterFields : [];


    //get tests based on service
    let service = this.state.selectedSample?.ServiceID ? this.props.services.find((s) => s.ID === this.state.selectedSample.ServiceID) : null;

    //check if service allows multiple tests
    let multiTestAllow = false;
    if (service) {
      multiTestAllow = service.AllowMultipleTests ? true : false;
    }

    //get associated tests for servcie
    let serviceAssociatedTests = [];
    let serviceAssociatedTestsLabels = [];
    if (service?.Tests) {
      for (let i = 0; i < service.Tests.length; i++) {
        for (let j = 0; j < this.props.testDetails.length; j++) {
          if (service.Tests[i] === this.props.testDetails[j].ID) {
            serviceAssociatedTests.push(this.props.testDetails[j]);
            serviceAssociatedTestsLabels.push({ label: this.props.testDetails[j].Name, value: this.props.testDetails[j].ID, });
          }
        }
      }
    }

    let selectedTestLabels = [];
    let selectedTests = [];
    if (this.state.selectedSample?.testIDs?.length > 0 && this.props.testDetails.length > 0) {
      if (multiTestAllow) {
        for (let i = 0; i < this.props.testDetails.length; i++) {
          for (let j = 0; j < this.state.selectedSample.testIDs.length; j++) {
            if (this.props.testDetails[i].ID === this.state.selectedSample.testIDs[j]) {
              selectedTestLabels.push({
                label: this.props.testDetails[i].Name,
                value: this.props.testDetails[i].ID,
              });
              selectedTests.push(this.props.testDetails[i]);
            }
          }
        }
      } else {
        let temp = this.props.testDetails.filter((t) => t.ID === this.state.selectedSample.testIDs[0]);
        selectedTestLabels.push({ label: temp[0].Name, value: temp[0].ID });
        selectedTests = selectedTests.concat(temp);
      }
    }

    //get specimen sources based on test(s) inclusive
    let selectedTestsSpecimenSourcesLabels = [];
    let selectedSpecimenSourceLabel;
    if (selectedTests?.length > 0) {
      let shortestObj = selectedTests.reduce((min_obj, obj) => min_obj.ValidSpecimenSources.length < obj.ValidSpecimenSources.length ? min_obj : obj);
      shortestObj.ValidSpecimenSources.map((vss) => {
        return selectedTestsSpecimenSourcesLabels.push({
          label: vss.Name,
          value: vss.ID,
        });
      });
      selectedSpecimenSourceLabel = this.props.specimen_source.find((s) => s.value === this.state.selectedSample.specimenSourceID);
    }

    //get results that have AllowNonStandardResultValue flag set to true
    let resultsThatAllowNonStandard = this.props.result_types?.filter((r) => r.AllowNonStandardResultValue);
    resultsThatAllowNonStandard = resultsThatAllowNonStandard?.map((r) => {
      return r.value;
    });

    //see if ResultValue in map
    let hasAdditionalResultValue = false;
    if (this.state.selectedSample?.testsAndResultsMap?.length > 0) {
      this.state.selectedSample.testsAndResultsMap.map((r) => {
        if (resultsThatAllowNonStandard.includes(r.ResultID)) {
          hasAdditionalResultValue = true;
        }
      });
    }


    let isEssentialOrComprehensive;
    if (service && service.ID) {
      if (process.env.REACT_APP_ENV === 'production') {
        if (productionEssentialAndComprehensiveServiceIDs.includes(service.ID)) {
          isEssentialOrComprehensive = true;
        }
      }
      else if (process.env.REACT_APP_ENV === 'demo') {
        if (demoEssentialAndComprehensiveServiceIDs.includes(service.ID)) {
          isEssentialOrComprehensive = true;
        }
      }
      else {
        if (developmentEssentialAndComprehensiveServiceIDs.includes(service.ID)) {
          isEssentialOrComprehensive = true;
        }
      }
    }


    return (
      <React.Fragment>
        <SampleInsuranceCardModal
          handleLoading={() =>
            this.setState({
              showInBetween: false,
              showLoadingForViewInsuranceCards: false,
            })
          }
          closeInBetween={() => this.setState({ showInBetween: false })}
          frontImage={this.state.frontInsuranceCardImage}
          backImage={this.state.backInsuranceCardImage}
          reqNum={this.state.selectedSample?.reqNum}
        />
        <InsuranceCardUploadModal
          frontUpload={(e) => this.onUpload("frontCardImgFile", e)}
          backUpload={(e) => this.onUpload("backCardImgFile", e)}
          clearFiles={() => this.clearFiles()}
          handleLoading={() => this.setState({ showInBetween: false })}
          closeInBetween={() => this.setState({ showInBetween: false })}
          handleImageSavedButton={(e) => this.setState({ imageSaved: e })}
          isDupe={false}
          clearImageState={() => this.setState({ frontCardImgFile: null, backCardImgFile: null })}
        />
        <InsuranceImageModal
          onFrontImgChange={(e) => this.onUpload("frontCardImgFile", e)}
          onBackImgChange={(e) => this.onUpload("backCardImgFile", e)}
          clearFiles={() => this.clearFiles()}
          handleLoading={() => this.setState({ showInBetween: false })}
          closeInBetween={() => this.setState({ showInBetween: false })}
          handleImageSavedButton={(e) => this.setState({ imageSaved: e })}
          captureClicked={this.state.captureClicked}
          clearImageState={() => this.setState({ frontCardImgFile: null, backCardImgFile: null })}
        />
        <Overlay show_loading={this.state.showLoading} />
        <Overlay show_loading={this.state.showLoadingForViewInsuranceCards || this.state.showLoadingForPhysicianReview} zIndex={100005} />
        <InBetweenOverlay showInBetween={this.state.showInBetween} />
        <div className="modal fade form_modal" id={AnimalSamplesModal.ID} tabIndex={-1} role="dialog" data-backdrop="static" data-keyboard="false" aria-label="Edit Sample" aria-hidden="true" >
          <div className="modal-dialog modal-lg modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-body p-0 m-0">
                <div className="container-fluid">
                  <div className={"row"}>
                    <div className="col-xl-12 col-lg-12 col-md-12 col-12 pt-2">
                      <div className="card mb-2">
                        <div className="card-header verlag-bold">
                          <h4>
                            Edit Sample
                            <button style={{ outline: "none" }} type="button" className="close mr-4" data-dismiss="modal" aria-label="Close" onClick={() => this.setState({ imageCached: false })} >
                              <span aria-hidden="true" style={{ fontSize: "1.5em", fontWeight: "bold", }} > &times; </span>
                            </button>
                          </h4>
                        </div>

                        <div className="card-body">
                          <div className={"row"}>
                            <div className="col-xl-12 pt-2">
                              <div className="card mb-2">
                                {/*Submitter*/}
                                <button className="card-header verlag-bold accordionButton w-100" data-toggle="collapse" data-target="#submitterXLCollapse" onClick={() => this.setState({ submitterArrowDown: !this.state.submitterArrowDown, })} aria-expanded="false" aria-controls="submitterXLCollapse">
                                  <div className="row justify-content-between px-3">
                                    <div className="">
                                      <h4>Submitter</h4>
                                    </div>
                                    <div className="col-2">
                                      {this.state.submitterArrowDown ? (
                                        <AiOutlineUp className={"float-right"} size={30} data-toggle="collapse" data-target="#submitterXLCollapse" role="button" aria-expanded="false" aria-controls="submitterXLCollapse" />
                                      ) : (
                                        <AiOutlineDown className={"float-right"} size={30} data-toggle="collapse" data-target="#submitterXLCollapse" role="button" aria-expanded="false" aria-controls="submitterXLCollapse" />
                                      )}
                                    </div>
                                  </div>
                                </button>
                                <div className="card-body collapse" id={"submitterXLCollapse"}>
                                  <div className="row">
                                    <div className="col-12 col-xl-6">
                                      <CustomInput fromFilterPage={false} required={true} value={this.state.selectedSample?.submitterFirstName} label={"First Name"} tooltip={"The first name of the Submitter"} handleChange={(e) => this.handleChange(e, "submitterFirstName")} />
                                      <CustomInput fromFilterPage={false} required={true} value={this.state.selectedSample?.submitterLastName} label={"Last Name"} tooltip={"The last name of the Submitter"} handleChange={(e) => this.handleChange(e, "submitterLastName")} />
                                      <CustomInput fromFilterPage={false} required={true} value={this.state.selectedSample?.submitterEmail} label={"Email"} tooltip={"The email of the Submitter"} maxLength={100} handleChange={(e) => this.handleChange(e, "submitterEmail")} />
                                      <CustomPhone fromFilterPage={false} required={true} value={this.state.selectedSample?.submitterPhone} label={"Phone"} tooltip={`The phone number of the Patien`} handleDateOnChange={(e) => this.handleDateOnChange(e, "submitterPhone")} />
                                    </div>
                                    <div className="col-12 col-xl-6">
                                      <div className="form-group row">
                                        <label htmlFor={'SearchAddress'} className="col-sm-4" style={{ fontWeight: 'bold', paddingTop: '0.5em', fontSize: "0.8em" }}>Search Address</label>
                                        <div className="col-sm-8  p-0 m-0" id={'SearchAddress'}>
                                          <AutoComplete key={"Submitterautocomplete"} id={"Submitterautocomplete"}
                                            onChange={(addr) => {
                                              this.setState((prevState) => ({ searchAddress: addr }))
                                            }}
                                            value={this.state.searchAddress}
                                            updateFormData={(addr, addr2, city, state, zip, county, country) => {
                                              let currentSample = this.state.selectedSample;
                                              currentSample.submitterAddress = addr;
                                              currentSample.submitterCity = city;
                                              currentSample.submitterState = getLabel(state, this.props.states).value;
                                              currentSample.stateLabel = getLabel(state, this.props.states);
                                              currentSample.submitterZip = zip;
                                              this.setState({ selectedSample: currentSample })
                                            }}
                                          />
                                        </div>
                                      </div>
                                      <CustomInput fromFilterPage={false} required={true} value={this.state.selectedSample?.submitterAddress} label={"Address"} tooltip={"The address of the Submitter"} maxLength={500} handleChange={(e) => this.handleChange(e, "submitterAddress")} />
                                      <CustomInput fromFilterPage={false} required={true} value={this.state.selectedSample?.submitterCity} label={"City"} tooltip={"The city of the Submitter"} maxLength={100} handleChange={(e) => this.handleChange(e, "submitterCity")} />
                                      <CustomSelect fromFilterPage={false} required={true} value={this.state.selectedSample?.stateLabel} label={"State"} tooltip={"The state of the Submitter's address"} handleChange={(e) => this.handleChange(e, "submitterState", "stateLabel", "select")} options={this.props.states} />
                                      <CustomInput fromFilterPage={false} required={true} value={this.state.selectedSample?.submitterZip} label={"Zip"} tooltip={"The zip of the Submitter"} handleChange={(e) => this.handleChange(e, "submitterZip")} />
                                    </div>
                                  </div>
                                  {/* <div className="row">
                                      {customSubmitterFields.map((val, index) => {
                                        if (val.Options.isActive) {
                                          if (index % 2 === 0) {
                                            return (
                                              <div className="col-12 col-xl-6">
                                                <div className="form-group row">
                                                  <GetField fromSamples={true} val={val} readOnly={getFieldReadOnly(val.DisplayName, this.props.userRoles, this.props.fieldPermissions)} selectedItem={ this.state.selectedSample? this.state.selectedSample : {} } handleChange={(e) => { this.setState({ selectedSample: e, }); }} />
                                                </div>
                                              </div>
                                            );
                                          } else if (index % 2 === 1) {
                                            return (
                                              <div className="col-12 col-xl-6">
                                                <div className="form-group row">
                                                  <GetField fromSamples={true} val={val} readOnly={getFieldReadOnly(val.DisplayName, this.props.userRoles, this.props.fieldPermissions)} selectedItem={ this.state.selectedSample? this.state .selectedSample : {} } handleChange={(e) => { this.setState({ selectedSample: e, }); }} />
                                                </div>
                                              </div>
                                            );
                                          }
                                        }
                                      })} 
                                  </div>*/}
                                </div>
                              </div>

                              {/* Appointment */}
                              <div className="card mb-2">
                                <button className="card-header verlag-bold accordionButton w-100" data-toggle="collapse" data-target="#appointmentXLCollapse" onClick={() => this.setState({ appointmentArrowDown: !this.state.appointmentArrowDown, })} aria-expanded="false" aria-controls="appointmentXLCollapse">
                                  <div className="row justify-content-between px-3">
                                    <div className="">
                                      <h4>Test Order</h4>
                                    </div>
                                    <div className="col-2">
                                      {this.state.appointmentArrowDown ? (
                                        <AiOutlineUp className={"float-right"} size={30} data-toggle="collapse" data-target="#appointmentXLCollapse" role="button" aria-expanded="false" aria-controls="appointmentXLCollapse" />
                                      ) : (
                                        <AiOutlineDown className={"float-right"} size={30} data-toggle="collapse" data-target="#appointmentXLCollapse" role="button" aria-expanded="false" aria-controls="appointmentXLCollapse" />
                                      )}
                                    </div>
                                  </div>
                                </button>
                                <div className="card-body collapse" id={"appointmentXLCollapse"}>
                                  <div className="row">
                                    <div className="col-12 col-xl-6">
                                      <CustomInput fromFilterPage={false} value={this.state.selectedSample?.linkedApptsID} label={"Appointment #"} tooltip={"A submitter's unique code tied to their appointment or submission form submission"} readOnly={true} />
                                      <CustomInput fromFilterPage={false} value={this.state.selectedSample?.reqNum} label={"Confirmation #"} tooltip={"A submitter's unique code tied to their sample"} readOnly={true} />
                                    </div>
                                    {/* <div className="col-12 col-xl-6">
                                      <CustomDate fromFilterPage={false} value={this.state.selectedSample?.apptTime} label={"Appointment Time"} tooltip={`Time of appointment`} timeOnly={true} handleDateOnChange={(e) => this.handleDateOnChange(e, "apptTime")} />
                                      <CustomSelect fromFilterPage={false} value={this.state.selectedSample?.apptCanceledLabel} label={"Canceled"} tooltip={`Appointment status. "Yes" returns canceled appointments, "No" returns active appointments.`} handleChange={(e) => this.handleChange(e, "apptCanceled", "apptCanceledLabel", "select")} options={getBoolOptionsWithNullValue()} />
                                    </div> */}
                                  </div>
                                </div>
                              </div>

                              {/*Sample*/}
                              <div className="card mb-2">
                                <button className="card-header verlag-bold accordionButton w-100" data-toggle="collapse" data-target="#sampleXLCollapse" onClick={() => this.setState({ sampleArrowDown: !this.state.sampleArrowDown, })} aria-expanded="false" aria-controls="sampleXLCollapse">
                                  <div className="row justify-content-between px-3">
                                    <div className="">
                                      <h4>Sample</h4>
                                    </div>
                                    <div className="col-2">
                                      {this.state.sampleArrowDown ? (
                                        <AiOutlineUp className={"float-right"} size={30} data-toggle="collapse" data-target="#sampleXLCollapse" role="button" aria-expanded="false" aria-controls="sampleXLCollapse" />
                                      ) : (
                                        <AiOutlineDown className={"float-right"} size={30} data-toggle="collapse" data-target="#sampleXLCollapse" role="button" aria-expanded="false" aria-controls="sampleXLCollapse" />
                                      )}
                                    </div>
                                  </div>
                                </button>
                                <div className="card-body collapse" id={"sampleXLCollapse"} >
                                  <div className="row">
                                    <div className="col-12 col-xl-6">
                                      <CustomInput fromFilterPage={false} value={this.state.selectedSample?.specimenID} label={"Specimen ID"} tooltip={"A unique identifier assigned to a sample"} handleChange={(e) => this.handleChange(e, "specimenID")} readOnly={this.disableCollectionRelevantFields("SpecimenID")} />
                                      <CustomInput fromFilterPage={false} value={this.state.selectedSample?.internalSpecimenID} label={"Internal Specimen ID"} tooltip={"A unique secondary identifier assigned to a sample"} handleChange={(e) => this.handleChange(e, "internalSpecimenID")} readOnly={!this.props.isGlobal} />
                                      {/* <CustomInput fromFilterPage={false} value={this.state.selectedSample?.rerunCount} label={"Rerun count"} tooltip={"Number of times a sample has been reran"} handleChange={(e) => this.handleChange(e, "rerunCount")} readOnly={!this.props.isGlobal} min={0} max={100} type={'number'} /> */}
                                      {/* <CustomSelect fromFilterPage={false} value={this.state.selectedSample?.rerunFlagLabel} label={"Rerun flag"} tooltip={`Samples marked for rerun. "Yes" returns samples marked for rerun.`} handleChange={(e) => this.handleChange(e, "rerunFlag", "rerunFlagLabel", "select")} options={getBoolOptionsWithNullValue()} disabled={!this.props.isGlobal} /> */}
                                      <CustomSelect fromFilterPage={false} value={this.state.selectedSample?.statusLabel} label={"Status"} tooltip={"Status of the sample"} disabled={true} handleChange={(e) => this.handleChange(e, "status", "statusLabel", "select")} options={this.props.statuses} />
                                      {/* <CustomSelect fromFilterPage={false} value={this.state.selectedSample?.bin} label={"Bin ID"} tooltip={`A unique identifier that ties a sample to receiving at the lab`} handleChange={(e) => this.handleChange(e, "binID", "bin", "select")} options={this.props.binIDs} disabled={!this.props.isGlobal} /> */}
                                      {/* <CustomSelect fromFilterPage={false} value={this.state.selectedSample?.batchNums} label={"Batch #"} tooltip={`Assigned when processing a batch of test samples`} handleChange={(e) => this.handleChange(e, "batchNum", "batchNums", "select")} options={this.props.batches} disabled={!this.props.isGlobal} /> */}
                                      {/* <CustomInput fromFilterPage={false} value={this.state.selectedSample?.wellSlot} label={"Well Slot"} tooltip={"Used by lab personnel to indicate a sample's position on a well plate"} handleChange={(e) => this.handleChange(e, "wellSlot")} readOnly={!this.props.isGlobal} /> */}
                                      {/* <CustomInput fromFilterPage={false} value={this.state.selectedSample?.lot} label={"Lot"} tooltip={"Test lot number (e.g., rapid test lot number.)"} handleChange={(e) => this.handleChange(e, "lot")} readOnly={this.disableCollectionRelevantFields("Lot")} /> */}
                                      {/* <CustomInput fromFilterPage={false} value={this.state.selectedSample?.receivedBy} label={"Received by"} tooltip={"The name of who received samples at the lab"} readOnly={true} /> */}
                                      {/* <CustomSelect fromFilterPage={false} value={this.state.selectedSample?.IncludeInHL7Label} label={"Include in HL7"} tooltip={`Indicates whether sample will be included in HL7 or not`} handleChange={(e) => this.handleChange(e, "IncludeInHL7", "IncludeInHL7Label", "select")} options={getBoolSelectOptions()} disabled={!this.props.isGlobal} /> */}
                                    </div>
                                    <div className="col-12 col-xl-6">
                                      <CustomDate fromFilterPage={false} hasTime={true} value={this.state.selectedSample?.collectionDate} label={"Collection Date"} tooltip={`Date a test sample was collected`} handleDateOnChange={(e) => this.handleDateOnChange(e, "collectionDate")} readOnly={this.disableCollectionRelevantFields("CollectionDate")} />
                                      <CustomDate fromFilterPage={false} hasTime={true} value={this.state.selectedSample?.testOrderedDate} label={"Test Ordered Date"} tooltip={`Date the test was ordered`} handleDateOnChange={(e) => this.handleDateOnChange(e, "testOrderedDate")} readOnly={this.disableCollectionRelevantFields("TestOrderedDate")} />
                                      <CustomDate fromFilterPage={false} hasTime={true} value={this.state.selectedSample?.receivedDate} label={"Received Date"} tooltip={`The date a sample was received at the lab`} handleDateOnChange={(e) => this.handleDateOnChange(e, "receivedDate")} readOnly={true} />
                                      <CustomDate fromFilterPage={false} hasTime={true} value={this.state.selectedSample?.processedDate} label={"Processed Date"} tooltip={`Date of sample accession`} handleDateOnChange={(e) => this.handleDateOnChange(e, "processedDate")} readOnly={!this.props.isGlobal} />
                                      <CustomDate fromFilterPage={false} hasTime={true} value={this.state.selectedSample?.testResultDate} label={"Test Result Date"} tooltip={`Date a result was assigned to a test sample (note: results are not sent to the submitter until they're approved`} handleDateOnChange={(e) => this.handleDateOnChange(e, "testResultDate")} readOnly={!this.props.isGlobal} />
                                      {/* <CustomDate fromFilterPage={false} hasTime={true} value={this.state.selectedSample?.resultApprovedDate} label={"Result Approved Date"} tooltip={`The date a result is approved and sent to the submitter`} handleDateOnChange={(e) => this.handleDateOnChange(e, "resultApprovedDate")} readOnly={true} /> */}
                                      {/* <CustomDate fromFilterPage={false} hasTime={true} value={this.state.selectedSample?.reportedDate} label={"Reported Date"} tooltip={`The date a sample result is reported to SpringML`} handleDateOnChange={(e) => this.handleDateOnChange(e, "reportedDate")} readOnly={true} /> */}
                                      {/* <CustomDate fromFilterPage={false} hasTime={true} value={this.state.selectedSample?.resultsAccessedDate} label={"Results Accessed Date"} tooltip={`The date a sample result is reported to SpringML`} handleDateOnChange={(e) => this.handleDateOnChange(e, "resultsAccessedDate")} readOnly={!this.props.isGlobal || !this.state.selectedSample?.resultApprovedDate} /> */}
                                      <CustomTextArea value={this.state.selectedSample?.memo} label={"Memo"} tooltip={"General sample notes"} handleChange={(e) => this.handleChange(e, "memo")} maxLength={1000} />
                                      <CustomSelect fromFilterPage={false} value={this.state.selectedSample?.animalTypeLabel} label={"Animal Type"} tooltip={"Type of Animal Sample was collected from"} handleChange={(e) => this.handleChange(e, "animalType", "animalTypeLabel", "select")} options={this.props.animalTypes} />
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/*Rabies Exposure info*/}
                              {this.state.selectedSample?.RabiesExposureInfo.length > 0  && this.state.selectedSample?.ServiceID === 52 ? <div className="card mb-2">
                                <button className="card-header verlag-bold accordionButton w-100" data-toggle="collapse" data-target="#rabiesXLCollapse" onClick={() => this.setState({ rabiesArrowDown: !this.state.rabiesArrowDown, })} aria-expanded="false" aria-controls="rabiesXLCollapse">
                                  <div className="row justify-content-between px-3">
                                    <div className="">
                                      <h4>Rabies Exposure Info</h4>
                                    </div>
                                    <div className="col-2">
                                      {this.state.rabiesArrowDown ? (
                                        <AiOutlineUp className={"float-right"} size={30} data-toggle="collapse" data-target="#rabiesXLCollapse" role="button" aria-expanded="false" aria-controls="rabiesXLCollapse" />
                                      ) : (
                                        <AiOutlineDown className={"float-right"} size={30} data-toggle="collapse" data-target="#rabiesXLCollapse" role="button" aria-expanded="false" aria-controls="rabiesXLCollapse" />
                                      )}
                                    </div>
                                  </div>
                                </button>
                                <div className="card-body collapse" id={"rabiesXLCollapse"} >
                                  {this.state.selectedSample?.RabiesExposureInfo.map((elem, index) => {
                                    return (
                                      <>
                                        {index > 0 ? <hr /> : null}
                                        <div className="row">
                                          <div className="col-12 col-xl-6">
                                            <CustomSelect fromFilterPage={false} value={this.state.selectedSample?.RabiesExposureInfo[index].ExposedSpecies} label={"Exposed Species"} tooltip={"Species that the rabies exposure came from"} handleChange={(e) => this.handleRabiesExposureUpdate(e, 'ExposedSpecies', index)} options={[{ label: "Human", value: 1 }, { label: "Animal", value: 2 }]} />
                                            <CustomInput fromFilterPage={false} value={this.state.selectedSample?.RabiesExposureInfo[index].FirstName} label={this.state.selectedSample.RabiesExposureInfo[index]?.ExposedSpecies?.value !== 2 ? 'First Name' : "Owner First Name"} tooltip={"First Name of Exposed individual"} handleChange={(e) => this.handleRabiesExposureUpdate(e.target.value, 'FirstName', index)} />
                                            <CustomInput fromFilterPage={false} value={this.state.selectedSample?.RabiesExposureInfo[index].LastName} label={this.state.selectedSample.RabiesExposureInfo[index]?.ExposedSpecies?.value !== 2 ? 'Last Name' : "Owner Last Name"} tooltip={"Last Name of Exposed individual"} handleChange={(e) => this.handleRabiesExposureUpdate(e.target.value, 'LastName', index)} />
                                            <div className="form-group row">
                                              <label htmlFor={'SearchAddress'} className="col-sm-4" style={{ fontWeight: 'bold', paddingTop: '0.5em', fontSize: "0.8em" }}>Search Address</label>
                                              <div className="col-sm-8  p-0 m-0" id={'SearchAddress'}>
                                                <AutoComplete key={"Exposureautocomplete"} id={"Exposureautocomplete"}
                                                  onChange={(addr) => {
                                                    let currentInfo = this.state.selectedSample.RabiesExposureInfo;
                                                    currentInfo[index].searchAddress = addr;
                                                    this.setState((prevState) => ({ selectedSample: {...this.state.selectedSample, RabiesExposureInfo: currentInfo} }))
                                                  }}
                                                  value={this.state.selectedSample.RabiesExposureInfo[index].searchAddress}
                                                  updateFormData={(addr, addr2, city, state, zip, county, country) => {
                                                    let currentInfo = this.state.selectedSample.RabiesExposureInfo;
                                                    currentInfo[index].StreetAddress = addr;
                                                    currentInfo[index].City = city;
                                                    currentInfo[index].State = getLabel(state, this.props.states);
                                                    currentInfo[index].Zipcode = zip;
                                                    this.setState({ selectedSample: {...this.state.selectedSample, RabiesExposureInfo: currentInfo} })
                                                  }}
                                                />
                                              </div>
                                            </div>
                                            <CustomInput fromFilterPage={false} value={this.state.selectedSample?.RabiesExposureInfo[index].StreetAddress} label={"Address"} tooltip={"Address of exposed individual"} handleChange={(e) => this.handleRabiesExposureUpdate(e.target.value, 'StreetAddress', index)} />
                                            <CustomInput fromFilterPage={false} value={this.state.selectedSample?.RabiesExposureInfo[index].City} label={"City"} tooltip={"City of exposed individual"} handleChange={(e) => this.handleRabiesExposureUpdate(e.target.value, 'City', index)} />
                                            <CustomSelect fromFilterPage={false} value={this.state.selectedSample?.RabiesExposureInfo[index].State} label={"State"} tooltip={"State of exposed individual"} handleChange={(e) => this.handleRabiesExposureUpdate(e, 'State', index)} options={this.props.states} />
                                            <CustomInput fromFilterPage={false} value={this.state.selectedSample?.RabiesExposureInfo[index].Zipcode} label={"Zipcode"} tooltip={"Zipcode of exposed individual"} handleChange={(e) => this.handleRabiesExposureUpdate(e.target.value, 'Zipcode', index)} />

                                            {/* <CustomInput fromFilterPage={false} value={this.state.selectedSample?.rerunCount} label={"Rerun count"} tooltip={"Number of times a sample has been reran"} handleChange={(e) => this.handleChange(e, "rerunCount")} readOnly={!this.props.isGlobal} min={0} max={100} type={'number'} /> */}
                                            {/* <CustomSelect fromFilterPage={false} value={this.state.selectedSample?.rerunFlagLabel} label={"Rerun flag"} tooltip={`Samples marked for rerun. "Yes" returns samples marked for rerun.`} handleChange={(e) => this.handleChange(e, "rerunFlag", "rerunFlagLabel", "select")} options={getBoolOptionsWithNullValue()} disabled={!this.props.isGlobal} /> */}
                                            {/* <CustomSelect fromFilterPage={false} value={this.state.selectedSample?.bin} label={"Bin ID"} tooltip={`A unique identifier that ties a sample to receiving at the lab`} handleChange={(e) => this.handleChange(e, "binID", "bin", "select")} options={this.props.binIDs} disabled={!this.props.isGlobal} /> */}
                                            {/* <CustomSelect fromFilterPage={false} value={this.state.selectedSample?.batchNums} label={"Batch #"} tooltip={`Assigned when processing a batch of test samples`} handleChange={(e) => this.handleChange(e, "batchNum", "batchNums", "select")} options={this.props.batches} disabled={!this.props.isGlobal} /> */}
                                            {/* <CustomInput fromFilterPage={false} value={this.state.selectedSample?.wellSlot} label={"Well Slot"} tooltip={"Used by lab personnel to indicate a sample's position on a well plate"} handleChange={(e) => this.handleChange(e, "wellSlot")} readOnly={!this.props.isGlobal} /> */}
                                            {/* <CustomInput fromFilterPage={false} value={this.state.selectedSample?.lot} label={"Lot"} tooltip={"Test lot number (e.g., rapid test lot number.)"} handleChange={(e) => this.handleChange(e, "lot")} readOnly={this.disableCollectionRelevantFields("Lot")} /> */}
                                            {/* <CustomInput fromFilterPage={false} value={this.state.selectedSample?.receivedBy} label={"Received by"} tooltip={"The name of who received samples at the lab"} readOnly={true} /> */}
                                            {/* <CustomSelect fromFilterPage={false} value={this.state.selectedSample?.IncludeInHL7Label} label={"Include in HL7"} tooltip={`Indicates whether sample will be included in HL7 or not`} handleChange={(e) => this.handleChange(e, "IncludeInHL7", "IncludeInHL7Label", "select")} options={getBoolSelectOptions()} disabled={!this.props.isGlobal} /> */}
                                          </div>
                                          <div className="col-12 col-xl-6">
                                            <CustomPhone fromFilterPage={false} value={this.state.selectedSample?.RabiesExposureInfo[index].PhoneNumber} label={"Phone"} tooltip={`The phone number of the exposed individual`} handleDateOnChange={(e) => this.handleRabiesExposureUpdate(e, 'PhoneNumber', index)} />
                                            <CustomDate fromFilterPage={false} hasTime={false} value={this.state.selectedSample?.RabiesExposureInfo[index].DateOfExposure} label={"Date of Exposure"} tooltip={`Date exposure occured`} handleDateOnChange={(e) => this.handleDateOnChange(e, "collectionDate")} readOnly={this.disableCollectionRelevantFields("CollectionDate")} />
                                            <CustomDate fromFilterPage={false} hasTime={false} value={this.state.selectedSample?.RabiesExposureInfo[index].DateOfCollection} label={"Date of Collection"} tooltip={`Date the potential rabies sample was collected`} handleDateOnChange={(e) => this.handleDateOnChange(e, "testOrderedDate")} readOnly={this.disableCollectionRelevantFields("TestOrderedDate")} />
                                            <CustomSelect fromFilterPage={false} value={this.state.selectedSample?.RabiesExposureInfo[index].ExposureType} label={"Exposure Type"} tooltip={"The form of exposure"} handleChange={(e) => this.handleRabiesExposureUpdate(e, 'ExposureType', index)} options={[{ label: "Bite", value: 1 }, { label: "Scratch", value: 2 }, { label: "Other", value: 3 }]} />
                                            {this.state.selectedSample && this.state.selectedSample[index]?.ExposureType?.value === 3 ? <CustomInput fromFilterPage={false} value={this.state.selectedSample?.RabiesExposureInfo[index].OtherExposureType} label={"Other Exposure Type"} tooltip={"Other Exposure Type"} handleChange={(e) => this.handleRabiesExposureUpdate(e.target.value, 'OtherExposureType', index)} /> : <></>}
                                            {/* <CustomDate fromFilterPage={false} hasTime={true} value={this.state.selectedSample?.resultApprovedDate} label={"Result Approved Date"} tooltip={`The date a result is approved and sent to the submitter`} handleDateOnChange={(e) => this.handleDateOnChange(e, "resultApprovedDate")} readOnly={true} /> */}
                                            {/* <CustomDate fromFilterPage={false} hasTime={true} value={this.state.selectedSample?.reportedDate} label={"Reported Date"} tooltip={`The date a sample result is reported to SpringML`} handleDateOnChange={(e) => this.handleDateOnChange(e, "reportedDate")} readOnly={true} /> */}
                                            {/* <CustomDate fromFilterPage={false} hasTime={true} value={this.state.selectedSample?.resultsAccessedDate} label={"Results Accessed Date"} tooltip={`The date a sample result is reported to SpringML`} handleDateOnChange={(e) => this.handleDateOnChange(e, "resultsAccessedDate")} readOnly={!this.props.isGlobal || !this.state.selectedSample?.resultApprovedDate} /> */}
                                            {/* <CustomTextArea value={this.state.selectedSample?.memo} label={"Memo"} tooltip={"General sample notes"} handleChange={(e) => this.handleChange(e, "memo")} maxLength={1000} /> */}
                                          </div>
                                        </div>
                                      </>
                                    )
                                  })}
                                </div>
                              </div> : <></>}

                              {/* Tests  */}
                              <div className="card mb-2">
                                <button className="card-header verlag-bold accordionButton w-100" data-toggle="collapse" data-target="#testXLCollapse" onClick={() => this.setState({ testArrowDown: !this.state.testArrowDown, })} aria-expanded="false" aria-controls="testXLCollapse">
                                  <div className="row justify-content-between px-3">
                                    <div className="">
                                      <h4>Tests</h4>
                                    </div>
                                    <div className="col-2">
                                      {this.state.testArrowDown ? (
                                        <AiOutlineUp className={"float-right"} size={30} data-toggle="collapse" data-target="#testXLCollapse" role="button" aria-expanded="false" aria-controls="testXLCollapse" />
                                      ) : (
                                        <AiOutlineDown className={"float-right"} size={30} data-toggle="collapse" data-target="#testXLCollapse" role="button" aria-expanded="false" aria-controls="testXLCollapse" />
                                      )}
                                    </div>
                                  </div>
                                </button>
                                <div className="card-body collapse" id={"testXLCollapse"}>
                                  <div className="row">
                                    <div className="col-12 col-xl-6">
                                      <CustomInput fromFilterPage={false} value={this.state.selectedSample?.ServiceID} label={"Test Order"} tooltip={"Test Order signed up for"} readOnly={true} services={this.props.services} />
                                    </div>
                                    <div className="col-12 col-xl-6">
                                      <CustomSelect fromFilterPage={false} value={selectedSpecimenSourceLabel ? selectedSpecimenSourceLabel : ''} label={"Specimen Source"} tooltip={`The type of sample that was collected`} handleChange={(e) => this.handleChange(e, "specimenSourceID", "specimenSource", "select")} options={selectedTestsSpecimenSourcesLabels} disabled={!this.state.selectedSample?.ServiceID || !this.state.selectedSample?.testIDs || this.state.selectedSample?.testIDs?.length < 1} />
                                    </div>
                                    <div className="col-12 col-xl-6">
                                      <CustomInput fromFilterPage={false} value={this.state.selectedSample?.bodySite} label={"Collection Location of Specimen (Body site)"} tooltip={"Location on the body where the sample was collected."} readOnly={true} />
                                    </div>
                                  </div>

                                  {multiTestAllow ? (selectedTestLabels && selectedTestLabels.map((st, index) => {
                                    return (
                                      <>
                                        {isEssentialOrComprehensive ?
                                          <div className="row">
                                            <div className={"col-12 col-xl-6"} >
                                              <CustomSelect fromFilterPage={false} value={st} label={"Test"} tooltip={`The testing methods`} handleChange={(e) => this.handleTestChange(e, 'multi', st)} options={serviceAssociatedTestsLabels} disabled={!this.state.selectedSample?.ServiceID} />
                                            </div>
                                            <div className="col-9 col-md-11 col-xl-5">
                                              <CustomInput id={`ResultValue${index}`} fromFilterPage={false} value={this.getSelectedResultNonStandardValue(st.value)} label={"Value"} tooltip={"Non-standard Result Value"} maxLength={100} disabled={(this.getSelectedResultValue(st.value) && !this.resultHasNonStandardResult(st.value)) || !this.getSelectedResultValue(st.value) || !this.state.selectedSample?.ServiceID || !this.state.selectedSample?.testIDs || this.state.selectedSample?.testIDs?.length < 1 || !this.state.selectedSample?.specimenSourceID || this.state.selectedSample?.resultIDs?.length < 1} handleChange={(e) => this.handleResultValueChange(e, 'multi', st)} />
                                            </div>
                                            <div className="d-inline d-xl-none col-1 pt-4 pt-md-1 mt-2 mt-md-0">
                                              <AiOutlineClose color={"#B30000"} size={30} onClick={(e) => selectedTestLabels?.length > 0 ? this.removeTest(selectedTestLabels[0].value, true) : null} />
                                            </div>

                                            <div className={this.state.selectedSample?.ServiceID && selectedTestLabels?.length > 0 ? "d-none d-xl-inline col-1 text-center" : "invisible"} >
                                              <AiOutlineClose color={"#B30000"} size={30} onClick={(e) => selectedTestLabels?.length > 0 ? this.removeTest(selectedTestLabels[0].value, true) : null} />
                                            </div>
                                          </div>
                                          :
                                          <div className="row">
                                            <div className={hasAdditionalResultValue ? "col-12 col-xl-4" : "col-12 col-xl-6"} >
                                              <CustomSelect fromFilterPage={false} value={st} label={"Test"} tooltip={`The testing methods`} handleChange={(e) => this.handleTestChange(e, 'multi', st)} options={serviceAssociatedTestsLabels} disabled={!this.state.selectedSample?.ServiceID} />
                                            </div>
                                            <div className={hasAdditionalResultValue ? "col-8 col-md-11 col-xl-4" : "col-9 col-md-11 col-xl-5"} >
                                              <CustomSelect fromFilterPage={false} resultSelect={true} value={this.getSelectedResultValue(st.value)} label={"Result"} tooltip={`The Result`} handleChange={(e) => this.handleResultChange(e, 'multi', st, index)} options={this.getResultOptions(st.value)} disabled={!this.state.selectedSample?.ServiceID || !this.state.selectedSample?.testIDs || this.state.selectedSample?.testIDs?.length < 1 || !this.state.selectedSample?.specimenSourceID} />
                                            </div>
                                            <div className="d-inline d-xl-none col-1 pt-4 pt-md-1 mt-2 mt-md-0">
                                              <AiOutlineClose color={"#B30000"} size={30} onClick={(e) => this.removeTest(st.value)} />
                                            </div>
                                            {hasAdditionalResultValue && (
                                              <div className="col-12 col-xl-3">
                                                <CustomInput id={`ResultValue${index}`} fromFilterPage={false} value={this.getSelectedResultNonStandardValue(st.value)} label={"Value"} tooltip={"Non-standard Result Value"} maxLength={100} disabled={(this.getSelectedResultValue(st.value) && !this.resultHasNonStandardResult(st.value)) || !this.getSelectedResultValue(st.value) || !this.state.selectedSample?.ServiceID || !this.state.selectedSample?.testIDs || this.state.selectedSample?.testIDs?.length < 1 || !this.state.selectedSample?.specimenSourceID || this.state.selectedSample?.resultIDs?.length < 1} handleChange={(e) => this.handleResultValueChange(e, 'multi', st)} />
                                              </div>
                                            )}
                                            <div className="d-none d-xl-inline col-1 text-center">
                                              <AiOutlineClose color={"#B30000"} size={30} onClick={(e) => this.removeTest(st.value)} />
                                            </div>
                                          </div>
                                        }
                                      </>
                                    );
                                  })
                                  ) : (
                                    //single test
                                    <>
                                      {isEssentialOrComprehensive ?
                                        <div className="row">
                                          <div className={"col-12 col-xl-6"} >
                                            <CustomSelect fromFilterPage={false} value={selectedTestLabels} label={"Test"} tooltip={`The testing methods`} handleChange={(e) => this.handleTestChange(e, 'single')} options={serviceAssociatedTestsLabels} disabled={!this.state.selectedSample?.ServiceID} />
                                          </div>
                                          <div className={"col-9 col-md-11 col-xl-5"} >
                                            <div className="col-12 col-xl-3">
                                              <CustomInput id={`ResultValueLabel`} fromFilterPage={false} value={selectedTestLabels?.length > 0 && this.getSelectedResultNonStandardValue(selectedTestLabels[0].value) ? this.getSelectedResultNonStandardValue(selectedTestLabels[0].value) : null} label={"Result Value"} tooltip={"Non-standard Result Value"} maxLength={100} disabled={!this.state.selectedSample?.ServiceID || !this.state.selectedSample?.testIDs || this.state.selectedSample?.testIDs?.length < 1 || !this.state.selectedSample?.specimenSourceID || this.state.selectedSample?.resultIDs?.length < 1} handleChange={(e) => this.handleResultValueChange(e, 'single')} />
                                            </div>
                                          </div>
                                          <div className="d-inline d-xl-none col-1 pt-4 pt-md-1 mt-2 mt-md-0">
                                            <AiOutlineClose color={"#B30000"} size={30} onClick={(e) => selectedTestLabels?.length > 0 ? this.removeTest(selectedTestLabels[0].value, true) : null} />
                                          </div>

                                          <div className={this.state.selectedSample?.ServiceID && selectedTestLabels?.length > 0 ? "d-none d-xl-inline col-1 text-center" : "invisible"} >
                                            <AiOutlineClose color={"#B30000"} size={30} onClick={(e) => selectedTestLabels?.length > 0 ? this.removeTest(selectedTestLabels[0].value, true) : null} />
                                          </div>
                                        </div>

                                        :
                                        <div className="row">
                                          <div className={hasAdditionalResultValue ? "col-12 col-xl-4" : "col-12 col-xl-6"} >
                                            <CustomSelect fromFilterPage={false} value={selectedTestLabels} label={"Test"} tooltip={`The testing methods`} handleChange={(e) => this.handleTestChange(e, 'single')} options={serviceAssociatedTestsLabels} disabled={!this.state.selectedSample?.ServiceID} />
                                          </div>
                                          <div className={hasAdditionalResultValue ? "col-8 col-md-11 col-xl-4" : "col-9 col-md-11 col-xl-5"} >
                                            <CustomSelect fromFilterPage={false}
                                              value={selectedTestLabels?.length > 0 ? this.getSelectedResultValue(selectedTestLabels[0].value) : null}
                                              label={"Result"} tooltip={`The Result`} handleChange={(e) => this.handleResultChange(e, 'single', null, null, selectedTestLabels)} options={selectedTestLabels?.length > 0 ? this.getResultOptions(selectedTestLabels[0].value) : []} disabled={!this.state.selectedSample?.ServiceID || !this.state.selectedSample?.testIDs || this.state.selectedSample?.testIDs?.length < 1 || !this.state.selectedSample?.specimenSourceID} />
                                          </div>
                                          <div className="d-inline d-xl-none col-1 pt-4 pt-md-1 mt-2 mt-md-0">
                                            <AiOutlineClose color={"#B30000"} size={30} onClick={(e) => selectedTestLabels?.length > 0 ? this.removeTest(selectedTestLabels[0].value, true) : null} />
                                          </div>
                                          {hasAdditionalResultValue && (
                                            <div className="col-12 col-xl-3">
                                              <CustomInput id={`ResultValueLabel`} fromFilterPage={false} value={selectedTestLabels?.length > 0 && this.getSelectedResultNonStandardValue(selectedTestLabels[0].value) ? this.getSelectedResultNonStandardValue(selectedTestLabels[0].value) : null} label={"Result Value"} tooltip={"Non-standard Result Value"} maxLength={100} disabled={!this.state.selectedSample?.ServiceID || !this.state.selectedSample?.testIDs || this.state.selectedSample?.testIDs?.length < 1 || !this.state.selectedSample?.specimenSourceID || this.state.selectedSample?.resultIDs?.length < 1} handleChange={(e) => this.handleResultValueChange(e, 'single')} />
                                            </div>
                                          )}
                                          <div className={this.state.selectedSample?.ServiceID && selectedTestLabels?.length > 0 ? "d-none d-xl-inline col-1 text-center" : "invisible"} >
                                            <AiOutlineClose color={"#B30000"} size={30} onClick={(e) => selectedTestLabels?.length > 0 ? this.removeTest(selectedTestLabels[0].value, true) : null} />
                                          </div>
                                        </div>
                                      }
                                    </>
                                  )}

                                  <div className="row">
                                    <div className="col-12 col-xl-6">
                                      <CustomInput fromFilterPage={false} value={this.state.selectedSample?.reason} label={"Result Reason"} tooltip={"Used by lab personnel to make notes about a sample's status or results"} handleChange={(e) => this.handleChange(e, "reason")} readOnly={!this.props.isGlobal} maxLength={500} />
                                    </div>
                                    <div className="col-6 col-xl-4 text-danger text-small pt-1">*Specimen Source resets with Test change</div>
                                    <div className="col-6 col-xl-2 pr-1">
                                      <button className={multiTestAllow && serviceAssociatedTests?.length > selectedTests?.length ? "btn btn-success float-right" : "d-none"} onClick={() => this.handleAddNewTest(serviceAssociatedTestsLabels)} >
                                        {!this.state.selectedSample?.testIDs ? "Add Test" : "Add Additional Test"}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/*Facility*/}
                              <div className="card mb-2">
                                <button className="card-header verlag-bold accordionButton w-100" data-toggle="collapse" data-target="#facilityXLCollapse" onClick={() => this.setState({ facilityArrowDown: !this.state.facilityArrowDown, })} aria-expanded="false" aria-controls="facilityXLCollapse" >
                                  <div className="row justify-content-between px-3">
                                    <div className="">
                                      <h4>Facility</h4>
                                    </div>
                                    <div className="col-2">
                                      {this.state.facilityArrowDown ? (
                                        <AiOutlineUp className={"float-right"} size={30} data-toggle="collapse" data-target="#facilityXLCollapse" role="button" aria-expanded="false" aria-controls="facilityXLCollapse" />
                                      ) : (
                                        <AiOutlineDown className={"float-right"} size={30} data-toggle="collapse" data-target="#facilityXLCollapse" role="button" aria-expanded="false" aria-controls="facilityXLCollapse" />
                                      )}
                                    </div>
                                  </div>
                                </button>
                                <div className="card-body collapse" id={"facilityXLCollapse"} >
                                  <div className="row">
                                    <div className="col-12 col-xl-6">
                                      <CustomSelect fromFilterPage={false} value={this.state.selectedSample?.facilityName} label={"Facility"} tooltip={`Testing locations by name`} handleChange={(e) => this.handleChange(e, "facilityID", "facilityName", "select")} options={this.props.facilities} />
                                      {/* <CustomSelect fromFilterPage={false} value={this.state.selectedSample?.podLabel} label={"Schedule"} tooltip={`Lists the Schedule ID, Facility Name, and Schedule Date`} handleChange={(e) => this.handleChange(e, "podApptID", "podLabel", "select")} options={pods} /> */}
                                    </div>
                                    <div className="col-12 col-xl-6">
                                      <CustomInput fromFilterPage={false} value={this.state.selectedSample?.providerFirstName} label={"Provider First Name"} tooltip={"The first name of the Provider that is assigned to a sample"} handleChange={(e) => this.handleChange(e, "providerFirstName")} readOnly={this.disableCollectionRelevantFields("ProviderFirstName")} />
                                      <CustomInput fromFilterPage={false} value={this.state.selectedSample?.providerLastName} label={"Provider Last Name"} tooltip={"The last name of the Provider that is assigned to a sample"} handleChange={(e) => this.handleChange(e, "providerLastName")} readOnly={this.disableCollectionRelevantFields("ProviderLastName")} />
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/*Custom Questionnaire Data*/}
                              {serviceQuestions && serviceQuestions.length > 0 ? (
                                <div className="card mb-2">
                                  <button className="card-header verlag-bold accordionButton w-100" data-toggle="collapse" data-target="#questionnaireDataXLCollapse" onClick={() => this.setState({ questionnaireDataArrowDown: !this.state.questionnaireDataArrowDown, })} aria-expanded="false" aria-controls="questionnaireDataXLCollapse" >
                                    <div className="row justify-content-between px-3">
                                      <div className="">
                                        <h4>Questionnaire Data</h4>
                                      </div>
                                      <div className="col-2">
                                        {this.state
                                          .questionnaireDataArrowDown ? (
                                          <AiOutlineUp className={"float-right"} size={30} data-toggle="collapse" data-target="#questionnaireDataXLCollapse" role="button" aria-expanded="false" aria-controls="questionnaireDataXLCollapse" />
                                        ) : (
                                          <AiOutlineDown className={"float-right"} size={30} data-toggle="collapse" data-target="#questionnaireDataXLCollapse" role="button" aria-expanded="false" aria-controls="questionnaireDataXLCollapse" />
                                        )}
                                      </div>
                                    </div>
                                  </button>
                                  <div className="card-body collapse" id={"questionnaireDataXLCollapse"} >
                                    <div className="row">
                                      {serviceQuestions.map((val, index) => {
                                        if (val.Options.isActive) {
                                          if (index % 2 === 0) {
                                            return (
                                              <div className="col-12 col-xl-6">
                                                <div className="form-group row">
                                                  <GetField fromSamples={true} isRequired={val.Options.isRequired} val={val} readOnly={getFieldReadOnly(val.DisplayName, this.props.userRoles, this.props.fieldPermissions)} selectedItem={this.state.selectedSample ? this.state.selectedSample : {}} handleChange={(e) => { this.setState({ selectedSample: e, }); }} />
                                                </div>
                                              </div>
                                            );
                                          } else if (index % 2 === 1) {
                                            return (
                                              <div className="col-12 col-xl-6">
                                                <div className="form-group row">
                                                  <GetField fromSamples={true} isRequired={val.Options.isRequired} val={val} readOnly={getFieldReadOnly(val.DisplayName, this.props.userRoles, this.props.fieldPermissions)} selectedItem={this.state.selectedSample ? this.state.selectedSample : {}} handleChange={(e) => { this.setState({ selectedSample: e, }); }} />
                                                </div>
                                              </div>
                                            );
                                          }
                                        }
                                      })}
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div className="invisible"></div>
                              )}

                              {/*Custom Field Data*/}
                              {customFieldDataQuestions && customFieldDataQuestions.length > 0 ? (
                                <div className="card mb-2">
                                  <button className="card-header verlag-bold accordionButton w-100" data-toggle="collapse" data-target="#customFieldDataXLCollapse" onClick={() => this.setState({ customFieldDataArrowDown: !this.state.customFieldDataArrowDown, })} aria-expanded="false" aria-controls="customFieldDataXLCollapse" >
                                    <div className="row justify-content-between px-3">
                                      <div className="">
                                        <h4>Custom Fields</h4>
                                      </div>
                                      <div className="col-2">
                                        {this.state.customFieldDataArrowDown ? (
                                          <AiOutlineUp className={"float-right"} size={30} data-toggle="collapse" data-target="#customFieldDataXLCollapse" role="button" aria-expanded="false" aria-controls="customFieldDataXLCollapse" />
                                        ) : (
                                          <AiOutlineDown className={"float-right"} size={30} data-toggle="collapse" data-target="#customFieldDataXLCollapse" role="button" aria-expanded="false" aria-controls="customFieldDataXLCollapse" />
                                        )}
                                      </div>
                                    </div>
                                  </button>
                                  <div className="card-body collapse" id={"customFieldDataXLCollapse"} >
                                    <div className="row">
                                      {customFieldDataQuestions.map(
                                        (val, index) => {
                                          if (val.Options.isActive) {
                                            if (index % 2 === 0) {
                                              return (
                                                <div className="col-12 col-xl-6">
                                                  <div className="form-group row">
                                                    <GetField fromSamples={true} isRequired={val.Options.isRequired} val={val} readOnly={getFieldReadOnly(val.DisplayName, this.props.userRoles, this.props.fieldPermissions)} selectedItem={this.state.selectedSample ? this.state.selectedSample : {}} handleChange={(e) => { this.setState({ selectedSample: e, }); }} />
                                                  </div>
                                                </div>
                                              );
                                            } else if (index % 2 === 1) {
                                              return (
                                                <div className="col-12 col-xl-6">
                                                  <div className="form-group row">
                                                    <GetField fromSamples={true} isRequired={val.Options.isRequired} val={val} readOnly={getFieldReadOnly(val.DisplayName, this.props.userRoles, this.props.fieldPermissions)} selectedItem={this.state.selectedSample ? this.state.selectedSample : {}} handleChange={(e) => { this.setState({ selectedSample: e, }); }} />
                                                  </div>
                                                </div>
                                              );
                                            }
                                          }
                                        }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div className="invisible"></div>
                              )}

                              {/*Insurance */}
                              <div className="card mb-2">
                                <button className="card-header verlag-bold accordionButton w-100" data-toggle="collapse" data-target="#insuranceXLCollapse" onClick={() => this.setState({ insuranceArrowDown: !this.state.insuranceArrowDown, })} aria-expanded="false" aria-controls="insuranceXLCollapse" >
                                  <div className="row justify-content-between px-3">
                                    <div className="">
                                      <h4>Insurance</h4>
                                    </div>
                                    <div className="col-2">
                                      {this.state.insuranceArrowDown ? (
                                        <AiOutlineUp className={"float-right"} size={30} data-toggle="collapse" data-target="#insuranceXLCollapse" role="button" aria-expanded="false" aria-controls="insuranceXLCollapse" />
                                      ) : (
                                        <AiOutlineDown className={"float-right"} size={30} data-toggle="collapse" data-target="#insuranceXLCollapse" role="button" aria-expanded="false" aria-controls="insuranceXLCollapse" />
                                      )}
                                    </div>
                                  </div>
                                </button>
                                <div className="card-body collapse" id={"insuranceXLCollapse"} >
                                  {this.state.selectedSample?.rerunCount > 0 ? (
                                    <div> Please see original record to manage insurance information. Be sure to change Rerun Flag to 'No' or blank in the filter to find original record </div>
                                  ) : (
                                    <>
                                      <div className="row mb-4 pr-1">
                                        <div className={"col-12 text-center text-xl-left"}>
                                          <div className="row justify-content-between">
                                            <div className="col-12 col-xl-3 font-weight-bold"> Insurance holder's information</div>
                                            <button className={this.state.selectedSample?.insuredFrontCard ? "d-xl-none col-12 mt-2 btn btn-success btn-sm mb-2 w-60" : "d-none"} onClick={() => this.getInsuranceCardImagesFromCloud()}> View Insurance Card Images </button>
                                            <button className={"d-xl-none col-12 mb-2 btn btn-success btn-sm w-60"} onClick={() => this.sampleInsuranceCardUpload()} > Add New Insurance Card Images </button>
                                            <div className={this.state.imageSaved ? "col-12 col-xl-2 pl-xl-0" : "invisible"}>
                                              <AiOutlineCheckCircle className={"ml-2"} color={"#14410B"} size={30} />
                                              <span className={"ml-1 text-success"} style={{ fontSize: "1em" }} > Images Saved </span>
                                            </div>
                                            <button className={this.state.selectedSample?.insuredFrontCard ? "d-none d-xl-inline col-xl-3 btn btn-success btn-sm" : "d-none"} onClick={() => this.getInsuranceCardImagesFromCloud()} > View Insurance Card Images </button>
                                            <button className={"d-none d-xl-inline col-xl-3 btn btn-success btn-sm"} onClick={() => this.sampleInsuranceCardUpload()} > Add New Insurance Card Images </button>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="row">
                                        <div className="col-12 col-xl-6">
                                          <CustomInput fromFilterPage={false} forInsurance={true} value={this.state.selectedSample?.insuredFirstName} label={"First Name"} tooltip={"First name of insurance holder"} handleChange={(e) => this.handleChange(e, "insuredFirstName")} />
                                          <CustomInput fromFilterPage={false} forInsurance={true} value={this.state.selectedSample?.insuredLastName} label={"Last Name"} tooltip={"Last name of insurance holder"} handleChange={(e) => this.handleChange(e, "insuredLastName")} />
                                          <CustomInput fromFilterPage={false} forInsurance={true} value={this.state.selectedSample?.insuredSSN} label={"Social Security #"} tooltip={"SSN of insurance holder"} handleChange={(e) => this.handleChange(e, "insuredSSN")} addDashes={(e) => this.addDashes(e, "insuredSSN")} />
                                          <CustomDate fromFilterPage={false} forInsurance={true} value={this.state.selectedSample?.insuredDOB} label={"DOB"} tooltip={`The date of birth of the insurance holder`} showDateWarning={true} handleDateOnChange={(e) => this.handleDateOnChange(e, "insuredDOB")} />
                                          <CustomInput fromFilterPage={false} forInsurance={true} value={this.state.selectedSample?.insuredMRN} label={"Medical Record #"} tooltip={"Medical Record Number of insurance holder"} handleChange={(e) => this.handleChange(e, "insuredMRN")} />
                                        </div>
                                        <div className="col-12 col-xl-6">
                                          <CustomInput fromFilterPage={false} forInsurance={true} value={this.state.selectedSample?.insuredAddressLine1} label={"Address"} tooltip={"Address of insurance holder"} handleChange={(e) => this.handleChange(e, "insuredAddressLine1")} maxLength={100} />
                                          <CustomInput fromFilterPage={false} forInsurance={true} value={this.state.selectedSample?.insuredAddressLine2} label={"Address Cont."} tooltip={"Address Cont. of insurance holder"} handleChange={(e) => this.handleChange(e, "insuredAddressLine2")} maxLength={100} />
                                          <CustomInput fromFilterPage={false} forInsurance={true} value={this.state.selectedSample?.insuredCity} label={"City"} tooltip={"City of insurance holder"} handleChange={(e) => this.handleChange(e, "insuredCity")} />
                                          <CustomSelect fromFilterPage={false} forInsurance={true} value={this.state.selectedSample?.insuredStateLabel} label={"State"} tooltip={`State of insurance holder`} handleChange={(e) => this.handleChange(e, "insuredState", "insuredStateLabel", "select")} options={this.props.states} />
                                          <CustomInput fromFilterPage={false} forInsurance={true} value={this.state.selectedSample?.insuredZip} label={"Zip"} tooltip={"Zipcode of insurance holder"} handleChange={(e) => this.handleChange(e, "insuredZip")} />
                                        </div>
                                      </div>
                                    </>
                                  )}
                                </div>
                              </div>

                              {/*File Upload */}
                              <div className="card mb-2">
                                <button className="card-header verlag-bold accordionButton w-100" data-toggle="collapse" data-target="#fileUploadXLCollapse" onClick={() => this.setState({ fileUploadArrowDown: !this.state.fileUploadArrowDown })} aria-expanded="false" aria-controls="fileUploadXLCollapse" >
                                  <div className="row justify-content-between px-3">
                                    <div className="">
                                      <h4>File Upload</h4>
                                    </div>
                                    <div className="col-2">
                                      {this.state.fileUploadArrowDown ? (
                                        <AiOutlineUp className={"float-right"} size={30} data-toggle="collapse" data-target="#fileUploadXLCollapse" role="button" aria-expanded="false" aria-controls="fileUploadXLCollapse" />
                                      ) : (
                                        <AiOutlineDown className={"float-right"} size={30} data-toggle="collapse" data-target="#fileUploadXLCollapse" role="button" aria-expanded="false" aria-controls="fileUploadXLCollapse" />
                                      )}
                                    </div>
                                  </div>
                                </button>
                                <div className="card-body collapse" id={"fileUploadXLCollapse"} >
                                  {this.state.selectedSample?.rerunCount > 0 ? (
                                    <div> Please see original record to manage file upload information. Be sure to change Rerun Flag to 'No' or blank in the filter to find original record </div>
                                  ) : (
                                    <>

                                      {this.state.selectedSample?.fileNames && this.state.selectedSample?.fileNames.length > 0 && this.state.selectedSample?.fileNames.map((fileName, index) => (
                                        <div className="form-group row">
                                          <label htmlFor={`SelectedFile${index}`} className="col-12 col-sm-4 col-form-label text-center text-md-left">Selected File #{index + 1}</label>
                                          <div className="col-8 col-sm-6 p-0 pt-2 m-0 text-center text-md-left" id={`SelectedFile${index}`}>
                                            {fileName}
                                          </div>
                                          <div className="col-2 col-sm-1">
                                            {!this.state.selectedFiles || this.state.selectedFiles.length < 1 || this.state.selectedFiles.find(f => f.name != fileName) ?
                                              <AiOutlineCloudDownload size={30} onClick={() => this.downloadFile(fileName)} />
                                              :
                                              <div></div>
                                            }
                                          </div>
                                          <div className="col-2 col-sm-1">
                                            <button style={{ outline: 'none' }} type="button" className="close" aria-label="Close" onClick={() => {
                                              this.removeFile(fileName)
                                            }}>
                                              <span aria-hidden="true">&times;</span>
                                            </button>
                                          </div>
                                        </div>
                                      ))}
                                      {this.state.selectedSample?.fileNames.length >= 10 ? <div className={"d-none"}></div> :
                                        <Dropzone onDrop={this.onDrop}>
                                          {({ getRootProps, getInputProps }) => (
                                            <section className="container p-0">
                                              <div {...getRootProps({ className: 'dropzone' })}>
                                                <input {...getInputProps()} />
                                                <p>Drag 'n' drop some files here, or click to select files</p>
                                              </div>
                                            </section>
                                          )}
                                        </Dropzone>
                                      }
                                    </>
                                  )
                                  }
                                </div>
                              </div>

                              {/* Additional  */}
                              <div className="card mb-2">
                                <button className="card-header verlag-bold accordionButton w-100" data-toggle="collapse" data-target="#additionalXLCollapse" onClick={() => this.setState({ additionalArrowDown: !this.state.additionalArrowDown, })} aria-expanded="false" aria-controls="additionalXLCollapse" >
                                  <div className="row justify-content-between px-3">
                                    <div className="">
                                      <h4>Additional</h4>
                                    </div>
                                    <div className="col-2">
                                      {this.state.additionalArrowDown ? (
                                        <AiOutlineUp className={"float-right"} size={30} data-toggle="collapse" data-target="#additionalXLCollapse" role="button" aria-expanded="false" aria-controls="additionalXLCollapse" />
                                      ) : (
                                        <AiOutlineDown className={"float-right"} size={30} data-toggle="collapse" data-target="#additionalXLCollapse" role="button" aria-expanded="false" aria-controls="additionalXLCollapse" />
                                      )}
                                    </div>
                                  </div>
                                </button>
                                <div className="card-body collapse" id={"additionalXLCollapse"} >
                                  <div className="row">
                                    <div className="col-12 col-xl-6">
                                      <CustomInput fromFilterPage={false} value={this.state.selectedSample?.createdBy} label={"Created By"} tooltip={"The username of who generated a record (applies primarily to walk-ins)"} readOnly={true} />
                                      <CustomInput fromFilterPage={false} value={this.state.selectedSample?.lastUpdatedBy} label={"Last Updated By"} tooltip={"The username of who last updated a record"} readOnly={true} />
                                      <CustomDate fromFilterPage={false} hasTime={true} value={this.state.selectedSample?.lastUpdatedDate} label={"Last Updated Date"} tooltip={`The date the record was last updated`} handleDateOnChange={(e) => this.handleDateOnChange(e, "lastUpdatedDate")} readOnly={true} />
                                    </div>
                                    <div className="col-12 col-xl-6">
                                      <CustomSelect fromFilterPage={false} value={this.state.selectedSample?.consentFlagLabel} label={"Consent Flag"} tooltip={`Did the submitter give consent?`} handleChange={(e) => this.handleChange(e, "consentFlag", "consentFlagLabel", "select")} options={getBoolOptionsWithNullValue()} />
                                      <CustomDate fromFilterPage={false} hasTime={true} value={this.state.selectedSample?.createdDate} label={"Created Date"} tooltip={`The date the record was generated`} handleDateOnChange={(e) => this.handleDateOnChange(e, "createdDate")} readOnly={true} />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {this.getLinks(service)}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}